import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core'
import { Router, ActivatedRoute } from '@angular/router'
import { ServicesProvider } from 'src/providers/services'
import { CalendarModalOptions } from 'ion2-calendar'
import { LoadingController, ModalController, ToastController, AlertController, IonContent, IonDatetime, PopoverController, Platform } from '@ionic/angular'
import { DatePipe, formatDate } from '@angular/common'
import { DatePikerPage } from '../date-piker/date-piker.page'
import { FileUploadService } from 'src/providers/upload'
import { PopupalertPage } from '../popupalert/popupalert.page'
import { DomSanitizer } from "@angular/platform-browser"
import { AdvanceFilterNursePage } from '../advance-filter-nurse/advance-filter-nurse.page'
import { AddmemPage } from '../addmem/addmem.page'
import { AddCall } from 'src/providers/addvCall'
import { ViewmodelPage } from '../viewmodel/viewmodel.page'
import { Geolocation } from '@ionic-native/geolocation/ngx'
import * as moment from 'moment'
declare let google
import { Payment } from 'src/providers/payment'
import { ModpricetagPage } from '../modpricetag/modpricetag.page'
import * as $ from 'jquery'
import { CommonService } from 'src/providers/common';
import { AdvertisementPage } from '../advertisement/advertisement.page';
import { SuccessPage } from 'src/app/success/success.page';
import { knetPaymentDetailsPage } from '../success/knetPaymentDetails/knetPaymentDetails.page';
import * as CryptoJS from 'crypto-js';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import * as htmlToPdfmake from 'html-to-pdfmake';
import { File } from '@ionic-native/file/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { HttpClient, HttpParams } from '@angular/common/http';
import { DefinedDutiesPage } from '../nurse-booking/defined-duties/defined-duties.page'
import { ReviewPage } from '../review/review.page'
pdfMake.vfs = pdfFonts?.pdfMake?.vfs;

interface DecryptedMemberContentResponse {
  data: { Terms_and_conditions: string }[];
}

@Component({
  selector: 'app-nursing',
  templateUrl: './nursing.page.html',
  styleUrls: ['./nursing.page.scss'],
})
export class NursingPage implements OnInit {
  @ViewChild('mydt') mydt: IonDatetime;
  @ViewChild(IonContent, { static: false }) content: IonContent;
  @ViewChild('map', { static: false }) mapElement: ElementRef;
  private fkey = CryptoJS.enc.Hex.parse(
    '00112233445566778899aabbccddeeff00112233445566778899aabbccddeeff'
  );
  private fiv = CryptoJS.enc.Hex.parse('00112233445566778899aabbccddeeff');

  @Input() nurseBookingId;
  @Input() patientId;
  @Input() nurseId;

  @Output() nurseDudtyUpdate = new EventEmitter<object>();
  @Output() ChangeEventNurse = new EventEmitter<string>();
  @Output() ChangeEvent = new EventEmitter<string>();
  map: any
  latitude: number
  longitude: number
  address: any
  mklike: any;
  rate: any
  presentView: string
  nursingPage: boolean
  nurseBookingProfile: boolean
  bookingConfim: boolean
  nurseProfileDetails: boolean
  mapPage: boolean
  costRange: any
  addDuties: any
  isConfirmed: boolean
  addSomething: any = []
  addLabel: any
  advFilter: boolean
  customPickerOptions: any
  selYear: any
  dateInfo: any
  date: string
  year: string
  month: string
  day: string
  curntDate: any
  from: any
  to: any
  terms_and_condition_file: any;
  dateRange: any
  defMonth: any = new Date("2023-10-07")
  patNurseSearch = []
  patNurseSearchforblock = []
  particularProfile: any
  minMaxCost = []
  costSorting: boolean
  experienceSorting: boolean
  ageSorting: boolean
  ratingSorting: boolean
  costBasedSortingOrder: any
  expBasedSortingOrder: any
  ageBasedSortingOrder: any
  ratingBasedSortingOrder: any
  toggleModel: boolean
  toggleModel1: boolean
  minMaxRating = []
  minRating: any
  maxRating: any
  ratingStatus: boolean
  minCost: any
  maxCost: any
  rateingRange: any
  chooseGender: any
  genderStatus: boolean
  costStatus: boolean
  particularNurseBook: any = []
  nationalityForNurse = []
  minMaxExperience = []
  minExp: any
  maxExp: any
  expRange: any
  expStatus: boolean
  chooseNationality: any
  natStatus: boolean
  stringFormate: string
  costRange1: any
  bookingConfirmationPage: any
  ratingvalue: any
  fromDate: any
  getFromTime: any
  workingHours: any
  workingHoursStatus: boolean
  toDate_validation: boolean = false
  toDate: any
  getToTime: any
  designedDuties: any
  excludeDates = []
  modelexcludday: []
  myDates: string
  today: any
  today2: any
  currentTime: any
  rangeFromDate: any
  rangeToDate: any
  confirmloc: boolean
  dutyArray = []
  dateFilter: boolean
  searchContent: any
  typeSearch: boolean
  skeletonLoad: any
  PatientProfile: any = []
  MyName: any
  pageno: any
  pageno1: any
  lastNurseId: any
  nextCount: any
  executed: any
  openNurseDetailIndex: any
  partBookingDetails = []
  Index: string
  fromResch: boolean
  nurseVendorId: any
  amount: any
  dtyArr: string
  tempMemberName: string
  isMember: any
  Enabled: boolean = false
  fromRepeat: boolean
  getFromTime1: any
  getToTime1: any
  withOutFilter: boolean = false
  totalSkeleten: any = []
  startDate: any;
  startDateCalendar: any;
  endDateCalendar: any;
  endDate: any
  Date: any
  excldDays: string
  tempDutyArray = []
  searchRequest: any
  eighthrs: any
  dutyAlert: any
  frmDateAlert: boolean
  toDateAlert: boolean
  frmTimeAlert: boolean
  toTimeAlert: boolean
  frmRepetDsgnDuty: any
  currentMemberId: any
  particullarnurseid: any
  reschedulePatientId: string
  optionsMulti2: CalendarModalOptions
  refEvent: any
  scrollEvent: any;
  adcall: any = 0;
  tymVal: any
  costReq: any
  minMaxExpReq: any
  minmaxRating: any
  getNationReq: any
  patProReq: any
  nurseBookReq: any
  bookDetReq: any
  nurseReschReq: any
  dutyCount: any
  dateCount: any
  dealOptn: any
  dealVal: any
  dateMulti: string[]
  price_per_day: any
  total_price_per_day: any
  type: 'string' // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  optionsMulti1: CalendarModalOptions = {
    pickMode: 'range',
    weekdays: [this.addCall.title411, this.addCall.title412, this.addCall.title413, this.addCall.title414, this.addCall.title415, this.addCall.title416, this.addCall.title417],
  }
  finalAmt: number
  datamodelService: any
  exdte = []
  myDates2: any
  con_view: boolean
  reviewcomment: any
  deletedata: any = [];
  dutyid: any = [];
  added_duties: any = [];
  showformated_date: any;
  dutyofMin: any; validation: any;
  dynClass: string;
  addImg: any;
  payType: any;
  gopayment: boolean = false;
  chipshow: boolean = false;
  dealId: any;
  temBlockednurse: any;
  isAndroid: any = null;
  isIos: any = null;
  isShows: boolean = false;

  defaultImage = 'assets/img/Vector.png';
  MaleImage = 'assets/newIcons/MaleJpg.jpg';
  FemaleImage = 'assets/newIcons/FeMaleJpg.jpg';
  startDate1: any
  endDate1: any
  dayDifference: any
  displayValue: any
  dateCalculation: any;
  balanceDaysDisplayValue: any
  getbookingNurseId: any
  total_price_month: any
  pricemonth: any;
  reviewCmt: any;
  reviewCommand: any;
  nurseRepeat: any;
  routeId: number;
  memberPaymentStatus: string
  payload: any
  vendorId: any
  oldtoDate: any

  constructor(
    public router: Router,
    public activeRoute: ActivatedRoute,
    private services: ServicesProvider,
    public toastController: ToastController,
    private datePipe: DatePipe,
    public modalCtrl: ModalController,
    private loadingCtrl: LoadingController,
    public fileupload: FileUploadService,
    public alertController: AlertController,
    public PopupalertPage: PopupalertPage,
    private sanitizer: DomSanitizer,
    public addCall: AddCall,
    public geolocation: Geolocation,
    private payment: Payment,
    private popoverctrl: PopoverController,
    private Common: CommonService,
    public toastCtrl: ToastController,
    private platform: Platform,
    private http: HttpClient,
    private file: File,
    private fileOpener: FileOpener,
    private httpClient: HttpClient,
    private cdr: ChangeDetectorRef) {
  }
  Latlan: any

  loadmap() {
    // Request needed libraries.
    let latLng = new google.maps.LatLng(this.latitude, this.longitude);
    let mapOptions = {
      center: latLng,
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      map: this.map,
    };
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);

    // Create a marker and set its position.
    let marker = new google.maps.Marker({
      position: latLng,
      map: this.map,
      title: "Current Location",
      animation: google.maps.Animation.DROP
    });

    // Configure the click listener.
    this.map.addListener("click", (mapsMouseEvent) => {
      let map_position = JSON.stringify(mapsMouseEvent.latLng.toJSON());
      let map_current_Lat_Long = JSON.parse(map_position);
      this.latitude = map_current_Lat_Long.lat;
      this.longitude = map_current_Lat_Long.lng;

      // Update marker position.
      marker.setPosition(mapsMouseEvent.latLng);

      let url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${this.latitude}&lon=${this.longitude}&zoom=18&addressdetails=1`;
      this.http.get(url).subscribe((res: any) => {
        let address_form = res.display_name;
        this.address = address_form;
        console.log(this.address, "address");
        this.cdr.detectChanges();
      },
        (error) => {
          console.log(error, "map_error");
        }
      );
    });
  }


  toggleCalendar() {
    this.isShows = !this.isShows;
  }

  onImageErrors(event: Event, value: any): void {
    if (value == 'Male') {
      const imgElement = event.target as HTMLImageElement;
      imgElement.src = this.MaleImage;
    } else if (value == 'Female') {
      const imgElement = event.target as HTMLImageElement;
      imgElement.src = this.FemaleImage;
    }
    else if (value == 'Vector') {
      const imgElement = event.target as HTMLImageElement;
      imgElement.src = this.defaultImage;
    }
  }

  getReverseGeocodingData(latitude, longitude) {
    let latlng = new google.maps.LatLng(latitude, longitude)
    let geocoder = new google.maps.Geocoder()
    geocoder.geocode({ 'latLng': latlng }, (results, status) => {
      if (status !== google.maps.GeocoderStatus.OK) {
        console.log(status);

      }
      if (status == google.maps.GeocoderStatus.OK) {
        let address = (results[0].formatted_address)
        this.address = address
      }
    })
  }

  opentime() {
    $('#time').click();
  }
  ScrollToBottom() {
    this.content.scrollToBottom(5000)
  }

  scrollit() {
    this.ScrollToBottom()
  }
  steddate: any

  onDateChanged($event) {
    this.dateInfo = $event
    let item = this.dateInfo.jsdate
    let dateArray = String(item).split(" ")
    this.year = dateArray[3]
    this.month = dateArray[1]
    this.day = item.toLocaleString('en-us', { weekday: 'long' })
  }
  excludayshow: any
  startexcludeddate: any
  endexcludedate: any

  onChange($event: any, type: any) {
    if (this.excludeDates.length == 1) {
      this.showformated_date = new Date().toString().split(' ')[0] + ", " + new Date().toString().split(' ')[1] + " " + new Date().toString().split(' ')[2]
    }
    this.pageno = 1
    this.dateInfo = $event
    if (type == "multi") {
      if ($event.length > 0) {
        let item = this.dateInfo[0]._d
        let dateArray = String(item).split(" ")
        this.year = dateArray[3]
        this.month = dateArray[1]
        this.day = item.toLocaleString('en-us', { weekday: 'long' })
      }
      this.excludeDates = []
      let formateArr = []
      this.myDates = null
      this.myDates2 = null
      this.exdte = []
      this.dateCount = null
      let i = 1
      this.excldDays = null
      for (let item of $event) {
        this.dateCount = i++
        let excl = item._d
        let exclDates = excl.getFullYear() + "-" + ("0" + (excl.getMonth() + 1)).slice(-2) + "-" + ("0" + (excl.getDate())).slice(-2)
        this.excludeDates.push(formatDate(exclDates, "dd-MMM-yy", "en-US"))
        if (this.excludeDates.length != 0) {
          this.showformated_date = new Date(this.excludeDates[0]).toString().split(' ')[0] + ", " + new Date(this.excludeDates[0]).toString().split(' ')[1] + " " + new Date(this.excludeDates[0]).toString().split(' ')[2]
        }

        this.myDates = this.excludeDates.join(", ")
        this.exdte.push(formatDate(exclDates, "yyyy-MM-dd", "en-US"))
        this.myDates2 = this.exdte.join(",")

        if (this.dateCount < 3) {
          let formate1 = this.getFormattedDateTime(exclDates, "Date1")
          formateArr.push(formate1)
          this.excldDays = formateArr.join(", ")
          this.excludayshow = formateArr
        }
      }
    } else {
      let getDate1 = this.dateInfo.from._d
      this.rangeFromDate = getDate1.getFullYear() + "-" + ("0" + (getDate1.getMonth() + 1)).slice(-2) + "-" + ("0" + (getDate1.getDate())).slice(-2)
      let getDate2 = this.dateInfo.to._d
      this.rangeToDate = getDate2.getFullYear() + "-" + ("0" + (getDate2.getMonth() + 1)).slice(-2) + "-" + ("0" + (getDate2.getDate())).slice(-2)
      this.dateFilter = true
    }
    debugger
    this.excludeDates.sort(function (a, b) {
      return new Date(a).getTime() - new Date(b).getTime()
    })
    let continues = false
    for (let i = 0; i < this.excludeDates.length - 1; i++) {
      if (moment(this.excludeDates[i + 1]).diff(moment(this.excludeDates[i]), "days") == 1) {
        continues = true
        this.con_view = true
      } else {
        continues = false
        this.con_view = false
        break
      }
    }

    if (continues)
      this.steddate = this.excludeDates[0] + " to " + this.excludeDates[this.excludeDates.length - 1]
    else {
      this.steddate = this.excludeDates.slice(0, 2).join(", ")
    }
  }

  //--------------\/-------SOME SPECIAL FUNCTION'S-------------\/----------

  async openDatePicker() {
    const datePickerModal = await this.modalCtrl.create({
      component: DatePikerPage,
      cssClass: 'datePicker',
      componentProps: {
        'selectedDate': new Date(this.fromDate),
        'calenderType': "normal",
        "messageFromNurse": "nurseDateof",
        curdate: new Date().toString().split(' ')[0] + ", " + new Date().toString().split(' ')[1] + " " + new Date().toString().split(' ')[2]
      }
    })
    await datePickerModal.present()

    datePickerModal.onDidDismiss()
      .then((data) => {
        if (data.data) {
          let Date = data.data
          this.fromDate = Date.getFullYear() + "-" + ("0" + (Date.getMonth() + 1)).slice(-2) + "-" + ("0" + (Date.getDate())).slice(-2)
          this.dynamicFromDate()
        }
      })
  }

  async openToDatePicker() {
    const datePickerModal = await this.modalCtrl.create({
      component: DatePikerPage,
      cssClass: 'datePicker',
      componentProps: {
        'selectedDate': new Date(),
        'calenderType': "normalToDate",
        "messageFromNurse": "nurseDateof",    //normal/dob
        curdate: new Date().toString().split(' ')[0] + ", " + new Date().toString().split(' ')[1] + " " + new Date().toString().split(' ')[2]
      }
    })
    await datePickerModal.present()

    datePickerModal.onDidDismiss()
      .then((data) => {
        if (data.data) {
          let Date = data.data
          this.toDate = Date.getFullYear() + "-" + ("0" + (Date.getMonth() + 1)).slice(-2) + "-" + ("0" + (Date.getDate())).slice(-2)
          this.endDate = this.getFormattedDateTime(this.toDate, "Date1")
        }
      })
  }

  async openAdvanceFilter() {
    const model = await this.modalCtrl.create({
      component: AdvanceFilterNursePage,
      cssClass: "ModelConCSS",
      componentProps: {
        "minMaxCost": this.minMaxCost[0],
        "minMaxExperience": this.minMaxExperience[0],
        "nationalityForNurse": this.nationalityForNurse,
        "minMaxRatng": this.minMaxRating[0]
      }
    })
    model.present()
    model.onDidDismiss().then((data) => {
      if (data.data != null) {
        if (data.data.nationaility != null) {
          this.chooseNationality = data.data.nationaility
          this.natStatus = true
        }
        if (data.data.costValue == null) {
          this.costRange = this.minCost
          this.costStatus = false
        }
        else {
          this.costRange = data.data.costValue
          this.costStatus = true
        }

        if (data.data.experience == null) {
          this.expRange = this.minExp
          this.expStatus = false
        }
        else {
          this.expRange = data.data.experience
          this.expStatus = true
        }
        if (data.data.rating == null) {
          this.rateingRange = this.minRating
          this.ratingStatus = true
        }
        else {
          this.rateingRange = data.data.rating
          this.ratingStatus = true

        }
        if (data.data.fromDate != null) {
          this.dateFilter = true
          this.rangeFromDate = data.data.fromDate
          this.rangeToDate = data.data.toDate
        }
        else {
          this.rangeFromDate = data.data.fromDate
          this.rangeToDate = data.data.toDate
        }
        this.toggleModel = data.data.dutyHour
        this.toggleModel1 = data.data.dutyHour
      }
    })
  }

  //--------------/\SOME SPECIAL FUNCTION'S-------------/\----------

  disablecal: any = []
  async ngOnInit() {
    this.activeRoute.queryParams.subscribe(params => {
      const id = params['id'];
      this.routeId = id;
      console.log(id, "sasaasasasa")
      localStorage.setItem("walkinId", String(this.routeId));
    });
    await this.paymentCheck();
    this.memberPaymentStatus = localStorage.getItem("paymentstatus");
    // this.ionViewWillEnter();
    this.totalSkeleten
    this.isConfirmed = false;
    this.address = "";
    for (let i = 1; i <= 30; i++) {
      this.totalSkeleten.push(i)
    }
    let date = new Date()
    let day = date.toLocaleString('en-us', { weekday: 'long' })
    this.curntDate = new Date
    this.curntDate = String(this.curntDate).split(" ")
    this.year = this.curntDate[3]
    this.month = this.curntDate[1]
    this.day = day
    this.activeRoute.queryParams.subscribe(params => {
      const id = params['id'];
      this.routeId = id;
      console.log(id, "sasaasasasa")
    });
    localStorage.setItem('bookindId', String(this.routeId));
    localStorage.setItem('VendorType', "5");
  }

  async getWalkinMemberDetails() {
    this.patNurseSearch = []
    this.skeletonLoad = 1
    let requestdata = {
      id: this.routeId
    }
    this.services.postRequest("getWalkinMemberDetails", requestdata).subscribe(async res => {
      localStorage.setItem("patient_id", res.data[0].patient_id);
      localStorage.setItem("patientName", res.data[0].patient_name);
      localStorage.setItem("Email", res.data[0].patient_mail);
      localStorage.setItem("patient_number", res.data[0].patient_number);
      localStorage.setItem("vendor_id", res.data[0].vendor_id);
      const response = res
      this.PatientProfile = response.data[0]
      this.MyName = response.data[0].patient_name
      this.particularProfile = response.data[0].patient_name;
      this.tempMemberName = response.data[0].patient_name;
      this.currentMemberId = response.data[0].patient_id;
      this.Email = response.data[0].patient_mail;
      this.Phoneno = response.data[0].patient_number;
      this.vendorId = response.data[0].vendor_id;
      this.initialfunctioncall()
    })
  }

  doRefresh(event: any, value: any) {
    this.refEvent = event
    if (value == "listNurse") {
      this.patNurseSearch = []
      this.typeSearch = false
      this.searchContent = ""
      this.costStatus = false
      this.expStatus = false
      this.natStatus = false
      this.chooseNationality = ""
      this.costSorting = false
      this.experienceSorting = false
      this.ageSorting = false
      this.ratingSorting = false
      this.pageno1 = 1
      this.lastNurseId = 0
      this.withOutFilter = true
      let timeDifference = this.endDate1 - this.startDate1;
      this.dayDifference = (timeDifference / (1000 * 3600 * 24)) + 1;
      if (this.dayDifference >= 7) {
        this.patientNurseSearch()
      }
    }
  }

  async rescheduleToast(text) {
    const toast = await this.toastController.create({
      message: text, duration: 2000, cssClass: 'myToastStyleBig',
    })
    toast.present()
  }

  getFormattedDateTime(dateTime, callFor) {
    if (!dateTime) {
      return "";
    }
    let Value;
    switch (callFor) {

      case "Time": {
        if (dateTime.indexOf("T") > -1) {
          Value = dateTime.split("T")[1];
        } else if (dateTime.indexOf(" ") > -1) {
          Value = dateTime.split(" ")[1];
        } else {
          Value = dateTime;
        }
        let hourEnd = Value.indexOf(":");
        let H = +String(Value).substring(0, hourEnd);
        let h = H % 12 || 12;
        let ampm = (H < 12 || H === 24) ? this.addCall.title458 : this.addCall.title459;
        let timeString = h + String(Value).substring(hourEnd, 5) + " " + ampm;
        if (h < 10) {
          timeString = '0' + timeString;
        }
        return timeString;
      }
      case "Date":
        return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy");
      case "DateTime":
        return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy h:mm a");
      case "DayDate":
        return this.datepipeTransform(new Date(dateTime), "EEE dd MMM yyyy");
      case "Date1":
        if (this.addCall.selectedLanguage == 'en') {
          return this.datepipeTransform(new Date(dateTime), "dd-MMM-yy");
        } else {
          let dateCall = new Date(dateTime);
          let months = ["يناير", "فبراير", "مارس", "إبريل", "مايو", "يونيو",
            "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"];
          let day = String(dateCall.getDate()).padStart(2, '0');
          let arDate = day + '-' + months[dateCall.getMonth()] + '-' + dateCall.getFullYear().toString().substr(-2);
          return arDate;
        }
    }
  }


  datepipeTransform(date: any, format: string): any {
    let dates = this.datePipe.transform(date, format)
    console.log(dates, "tttttt");
    return dates

  }

  //------------------Pages--------------------
  async ionViewWillEnter() {
    this.nurseRepeat = false;
    this.pricemonth = false;
    this.isShows = true;
    this.isAndroid = null;
    this.isIos = null;
    this.isConfirmed = false;
    this.address = "";
    if (this.platform.is('ios')) {
      this.isIos = 1;
    } else if (this.platform.is('android')) {
      this.isAndroid = 1;
    }
    if (localStorage.getItem("NopayGoBack") == "newEnter") {
      this.adcall += 1;
    }
    if (localStorage.getItem("NopayGoBack") == "editdesign" || localStorage.getItem("NopayGoBack") == "repeatPage") {
      console.log(localStorage.getItem("NopayGoBack"));
    }
    this.showcoment = false;
    this.showformated_date = new Date().toString()?.split(' ')[0] + ", " + new Date().toString()?.split(' ')[1] + " " + new Date().toString()?.split(' ')[2]
    this.frm = 0;
    this.getFromTime = "";
    this.getToTime = "";
    this.geolocation.getCurrentPosition({
      enableHighAccuracy: true,
      timeout: 5000
    }).then((resp) => {
      this.latitude = resp.coords.latitude;
      this.longitude = resp.coords.longitude;
      console.log(resp.coords.latitude);
      console.log(resp.coords.longitude);
    });
    // let startingDate = new Date().setDate(new Date().getDate() + 1);
    // let startingDate = new Date().setDate(new Date().getDate() + 1)
    let new_date = new Date();
    let startingDate = new_date.setDate(new_date.getDate() + 1);
    this.startDate = this.getFormattedDateTime(startingDate, "Date1");
    this.startDateCalendar = this.datepipeTransform(new Date(startingDate), "dd-MMM-yy");
    let getDate = new Date();
    let currentDateforNurse = getDate.getFullYear() + "-" + ("0" + (getDate.getMonth() + 1)).slice(-2) + "-" + ("0" + getDate.getDate()).slice(-2);
    const numberOfDays = 1
    this.fromDate = this.calculateEndDate(currentDateforNurse, numberOfDays);
    let endDate = new_date.setDate(new_date.getDate() + 6);
    // let endDate = new Date().setDate(new Date(this.fromDate).getDate() + 7)
    this.endDate = this.getFormattedDateTime(endDate, "Date1")
    this.endDateCalendar = this.datepipeTransform(new Date(endDate), "dd-MMM-yy");
    this.toDate = new Date(endDate).toISOString()?.split("T")[0]
    await this.getWalkinMemberDetails();
    this.optionsMulti2 = {
      pickMode: 'multi',
      weekdays: [this.addCall.title411, this.addCall.title412, this.addCall.title413, this.addCall.title414, this.addCall.title415, this.addCall.title416, this.addCall.title417],
      from: this.startDate,
      to: this.endDate,
    }
    this.currentMemberId = localStorage.getItem("patient_id");
  }

  async initialfunctioncall(){
    
    switch (localStorage.getItem("NopayGoBack")) {
      case "newEnter": {
        this.showNursingPage('newEnter')
        break
      }
      case "backToNurseListPage": {
        this.showNursingPage('backToNurseListPage')
        break
      }
      case "BookingConPage": {
        this.openBooking("")
        break
      }
      case "reschedulePage": {
        this.openNurseBooking(this.openNurseDetailIndex)
        break
      }
      case "repeatPage": {

        this.openNurseBooking(this.openNurseDetailIndex)
        break
      }
      case "editdesign": {
        this.openNurseBooking(this.openNurseDetailIndex);
        this.dutyArray = [];
        this.deletedata = [];
        break
      }
      case "nursedetails": {
        this.openNurseDetails(JSON.parse(this.activeRoute.snapshot.paramMap.get('item')))
        break
      }
      case "nursedetailshistory": {
        this.openNurseDetails(JSON.parse(this.activeRoute.snapshot.paramMap.get('item')))
        break
      }
      default: {
        await this.getbookingdetails();
      }
    }
  }

  calculateEndDate(startDate, numberOfDays) {
    const start = new Date(startDate);
    const end = new Date(start);
    end.setDate(start.getDate() + numberOfDays);
    const formattedEndDate = end.toISOString()?.split('T')[0];
    return formattedEndDate;
  }

  ionViewWillLeave() {
    this.scrollEvent = null;
    this.steddate = null;
    this.con_view = true;
    this.endDate = null;
    this.toDate = null;
  }

  async showNursingPage(type: any) {
    this.executed = true
    this.patNurseSearch = [{}];
    this.skeletonLoad = 0;
    this.searchContent = ""
    if (this.searchContent != "") {
      this.typeSearch = true
    } else {
      this.typeSearch = false
    }
    this.minCost = ""
    this.costRange = ""
    this.costRange1 = ""
    this.minExp = ""
    this.expRange = ""
    this.natStatus = false
    this.chooseNationality = ""
    this.rangeFromDate = this.fromDate
    this.rangeToDate = this.toDate
    this.chooseGender = ""
    this.expStatus = false
    this.genderStatus = false
    this.costStatus = false
    this.toggleModel = true
    this.toggleModel1 = this.toggleModel
    this.costBasedSortingOrder = "ASC"
    this.expBasedSortingOrder = "ASC"
    this.ageBasedSortingOrder = "ASC"
    this.ratingBasedSortingOrder = "ASC"
    this.experienceSorting = false
    this.costSorting = false
    this.ageSorting = false
    this.ratingSorting = false
    await this.getNurseList(1);
    await this.getNationalityForNurse()
    await this.minMaxExperienceForNurse()
    await this.minMaxCostForNurse()
    this.presentView = "nursingPage"
    this.nursingPage = true
    this.nurseBookingProfile = false
    this.bookingConfim = false
    this.nurseProfileDetails = false
    this.mapPage = false
    this.advFilter = false
    this.fromDate = this.fromDate
    this.toDate = this.toDate
    this.addSomething = []
    this.myDates = ""
    this.dateFilter = true
  }

  backToHome() {
    debugger;
    this.router.navigate(['/tabs/home'])
    this.nursingPage = false
    this.nurseBookingProfile = false
    this.bookingConfim = false
    this.nurseProfileDetails = false
    this.mapPage = false
    this.startDate = null
    this.endDate = null
    this.fromDate = null
    this.toDate = null
    this.dutyofMin = false;
    this.advFilter = false
    this.chooseNationality = ""
    this.isConfirmed = false;
    this.address = "";
  }
  getNurseID(item) {
    console.log("itemmmmm", item.NurseId);
    this.getbookingNurseId = item.NurseId
  }
  openNurseBooking(index) {
    debugger;
    if (index != undefined) {
      this.addtempbooked(index);
    }
    else {
      this.showcoment = false;
      this.dutyAlert = false;
      this.addSomething = [];
      this.dateRange = []
      this.nursingPage = false;
      this.dateCount = null;
      this.getFromTime1 = this.getFromTime
      this.getToTime1 = this.getToTime
      this.excldDays = null;
      this.myDates2 = null;
      this.openNurseDetailIndex = index

      if (localStorage.getItem("NopayGoBack") == "reschedulePage") {
        this.fromResch = true
        this.fromRepeat = false
        this.nurseBookingId = this.nurseBookingId; //this.activeRoute.snapshot.paramMap.get('nurseBookingId')
        this.reschedulePatientId = this.patientId; //this.activeRoute.snapshot.paramMap.get('patientId')
        this.particularBookingDetails()
        this.Enabled = false
      } else if (localStorage.getItem("NopayGoBack") == "repeatPage") {
        this.frmDateAlert = false
        this.frmTimeAlert = false
        this.toTimeAlert = false
        this.fromRepeat = false;
        this.fromResch = false
        this.nurseRepeat = true;
        this.nurseBookingId = this.nurseBookingId;
        this.currentMemberId = this.patientId;
        this.particularNurseBook = []
        this.particularBookingDetails()
        this.getPatientProfile()
        this.Enabled = false

      }
      else if (localStorage.getItem("NopayGoBack") == "editdesign") {
        this.fromResch = true
        this.fromRepeat = false
        // this.nurseBookingProfile = true;
        this.nurseBookingId = this.nurseBookingId;
        this.currentMemberId = this.patientId;
        this.particullarnurseid = this.nurseId;
        this.particularBookingDetails()
        this.Enabled = false
      }
      else {
        this.addDuties = "";
        this.frmDateAlert = false;
        this.frmTimeAlert = false;
        this.fromRepeat = false;
        this.fromResch = false;
        this.dateRange = null;
        this.excludeDates = [];
        this.particularNurseBook = [];
        this.finalAmt = null;
        this.particularNurseBook.push(this.patNurseSearch[index])
        this.presentView = "nurseBookingProfile"
        this.nurseBookingProfile = true
        this.bookingConfim = false
        this.nurseProfileDetails = false
        this.mapPage = false
        this.getFromTime = "2016-07-27T04:00:00Z"
        if (this.particularNurseBook[0].eightHour == 'true') {
          this.getFromTime = ""
          this.getToTime = ""
        }
        else {
          this.getFromTime = ""
          this.getToTime = ""
        }

        this.advFilter = false
        this.addLabel = false

        if (this.particularNurseBook[0].eightHour == 'true') {
          this.workingHours = "12:00"
        } else {
          this.workingHours = "24:00"
        }

        this.ratingvalue = this.particularNurseBook[0].review
        this.nurseId = this.particularNurseBook[0].NurseId
        this.nurseVendorId = this.particularNurseBook[0].nurseVendorId
        this.amount = this.particularNurseBook[0].Cost
        // this.particularnurse_revlike();
        this.dealVal = this.particularNurseBook[0]?.dealsDetails[0]?.dealValue
        this.dealId = this.particularNurseBook[0]?.dealsDetails[0]?.dealId;

        if (this.particularNurseBook[0]?.dealsDetails[0]?.dealOption == "Amount") {
          this.dealOptn = "KWD"
          this.finalAmt = this.amount - this.dealVal
        } else if (this.particularNurseBook[0]?.dealsDetails[0]?.dealOption == "Percentage") {
          this.dealOptn = "%"
          this.finalAmt = this.amount - ((Number(this.amount) * (this.dealVal)) / 100)
        }
        else if (this.particularNurseBook[0].dealsDetails) {
          this.dealOptn = null
          this.dealVal = 0
          this.dealId = null;
          this.finalAmt = this.amount
        }
        this.optionsMulti2 = {
          pickMode: 'multi',
          weekdays: [this.addCall.title411, this.addCall.title412, this.addCall.title413, this.addCall.title414, this.addCall.title415, this.addCall.title416, this.addCall.title417],
          from: this.startDate,
          to: this.endDate,
          defaultDate: this.fromDate,
          defaultDateRange: { from: this.fromDate, to: this.toDate }
        }
      }

      getMonthDifference(new Date(), new Date(this.startDate))
      function getMonthDifference(startDate, endDate) {
        let monthdiff = endDate.getMonth() - startDate.getMonth() + 12 * (endDate.getFullYear() - startDate.getFullYear())
        for (let i = 1; i <= monthdiff; i++) {
          setTimeout(() => {
            $(".forward").trigger("click");
          }, 1000);
        }
      }
    }
    if (this.particularNurseBook[index].review_comments) {
      if (JSON.parse(this.particularNurseBook[index].review_comments).length > 1) {
        this.reviewCmt = JSON.parse(this.particularNurseBook[index].review_comments);
      } else {
        this.reviewCmt = JSON.parse(this.particularNurseBook[index].review_comments);
      }
      this.reviewCommand = JSON.parse(this.particularNurseBook[index].review_comments)[0];
    } else {
      this.reviewCmt = [];
      this.reviewCommand = [];
    }
    console.log("Review Comments - ", this.reviewCmt, this.reviewCommand);





    // if (this.particularNurseBook && this.particularNurseBook[index]) {
    //   const reviewComments = this.particularNurseBook[index].review_comments;

    //   if (reviewComments) {
    //     try {
    //       const parsedComments = JSON.parse(reviewComments);
    //       if (parsedComments.length > 1) {
    //         this.reviewCmt = parsedComments;
    //       } else {
    //         this.reviewCmt = parsedComments;
    //       }
    //       this.reviewCommand = parsedComments[0];
    //     } catch (error) {
    //       console.error("Error parsing review_comments:", error);
    //       this.reviewCmt = [];
    //       this.reviewCommand = [];
    //     }
    //   } else {
    //     this.reviewCmt = [];
    //     this.reviewCommand = [];
    //   }
    // } else {
    //   console.error("particularNurseBook or index is undefined.");
    //   this.reviewCmt = [];
    //   this.reviewCommand = [];
    // }

    // console.log("Review Comments - ", this.reviewCmt, this.reviewCommand);

    debugger
    const parseDate = (dateStr, locale) => {
      const [day, monthName, year] = dateStr.split('-');
      const dateFormatter = new Intl.DateTimeFormat(locale, { month: 'long' });
      const months = [];
      for (let i = 0; i < 12; i++) {
        const month = dateFormatter.format(new Date(2024, i, 1));
        months.push(month);
      }

      const monthIndex = months.findIndex(month => month === monthName.trim());
      if (monthIndex === -1) {
        throw new Error(`Invalid month name: ${monthName}`);
      }
      return new Date(year, monthIndex, day);
    };

    if (this.addCall.selectedLanguage == 'ea') {
      this.startDate1 = parseDate(this.startDate, 'ar-EG'); // Arabic locale
      this.endDate1 = parseDate(this.endDate, 'ar-EG');
    } else {
      this.startDate1 = new Date(this.startDate); // Assuming English format
      this.endDate1 = new Date(this.endDate);
    }
    let timeDifference = this.endDate1 - this.startDate1;
    this.dayDifference = (timeDifference / (1000 * 3600 * 24)) + 1;


    if (this.dayDifference >= 30) {
      this.dateCalculation = localStorage.getItem("selectedLanguage") === 'en' ? "Month" : "شهر";
    } else {
      this.dateCalculation = localStorage.getItem("selectedLanguage") === 'en' ? "Day" : "يوم";
    }
    // Calculate full months and remaining days
    let fullMonths = Math.floor(this.dayDifference / 30);
    let remainingDays = this.dayDifference % 30;
    debugger
    let displayValue;
    displayValue = `${this.dayDifference} day${this.dayDifference > 1 ? 's' : ''}`;
    this.displayValue = displayValue;
    if (this.dayDifference >= 30) {
      this.pricemonth = true;
      this.total_price_per_day = "";
      this.price_per_day = this.particularNurseBook[index]?.CostMonth;
      let total_new_price = fullMonths * this.particularNurseBook[index]?.CostMonth + remainingDays * this.particularNurseBook[index]?.Cost
      if (this.particularNurseBook[index].dealsDetails.length > 0) {
        if (this.particularNurseBook[index]?.dealsDetails[0]?.dealOption == "Percentage") {
          this.total_price_per_day = (total_new_price) - ((total_new_price / 100) * (this.particularNurseBook[index].dealsDetails[0].dealValue));
        } else {
          this.total_price_per_day = total_new_price - this.particularNurseBook[index]?.dealsDetails[0]?.dealValue;
        }
      } else {
        this.total_price_per_day = total_new_price;
      }
    } else {
      this.pricemonth = false;
      this.total_price_per_day = "";
      this.price_per_day = this.particularNurseBook[index]?.Cost;
      let total_new_price = this.dayDifference * this.particularNurseBook[index]?.Cost
      if (this.particularNurseBook[index]?.dealsDetails.length > 0) {
        if (this.particularNurseBook[index]?.dealsDetails[0]?.dealOption == "Percentage") {
          this.total_price_per_day = (total_new_price) - ((total_new_price / 100) * (this.particularNurseBook[index].dealsDetails[0].dealValue));
        } else {
          this.total_price_per_day = total_new_price - this.particularNurseBook[index]?.dealsDetails[0]?.dealValue;
        }
      } else {
        this.total_price_per_day = total_new_price;
      }
    }
  }

  setEnable(date: any) {
    this.Enabled = true
    if (date == 'fromdate') {
      this.openDatePicker();
    } else if (date == 'todate') {
      this.openToDatePicker();
    }
  }

  formDateto(startDate, numberOfDays) {
    const start = new Date(startDate);
    const end = new Date(start);
    end.setDate(start.getDate() + numberOfDays);
    const formattedEndDate = end;
    return formattedEndDate;
  }
  toDatedefault(startDate, numberOfDays) {
    const start = new Date(startDate);
    const end = new Date(start);
    end.setDate(start.getDate() + numberOfDays);
    const formattedEndDate = end;
    return formattedEndDate;
  }
  dateDif(fromDate1, toDate1) {
    const startDate = new Date(fromDate1);
    const endDate = new Date(toDate1);
    const timeDifference = endDate.getTime() - startDate.getTime();
    const dayDifference = timeDifference / (1000 * 3600 * 24);
    const totalDays = Math.round(dayDifference);
    return totalDays;
  }

  dynamicFromDate() {
    this.fromDate = new Date(this.fromDate)
    const numberOfDays = 29;
    let date1 = this.formDateto(this.fromDate, numberOfDays);
    this.toDate = date1
    this.startDate = this.getFormattedDateTime(this.fromDate, "Date1")
    debugger;
    // Parse the fromDate and toDate
    this.fromDate = new Date(this.fromDate);
    this.toDate = new Date(this.endDate);
  
    // Format dates using moment
    const startf1 = moment(this.fromDate).format("YYYY-MM-DD");
    const endtf1 = moment(this.toDate).format("YYYY-MM-DD");
  
    // Calculate the difference in days between fromDate and toDate
    const difDate = this.dateDif(startf1, endtf1);
  
    // Check if the date difference is less than 6 days
    if (difDate < 6) {
      // Update toDate only if the difference is less than 6 days
      const numberOfDays = 6;
      let newToDate = this.formDateto(this.fromDate, numberOfDays);
      this.toDate = newToDate;
      this.endDate = this.getFormattedDateTime(newToDate, "Date1");
    } else {
      // If difference is 6 or more days, keep the current toDate
      this.endDate = this.getFormattedDateTime(this.toDate, "Date1");
    }
  
    // Format the start date for display
    this.startDate = this.getFormattedDateTime(this.fromDate, "Date1");

    let getDate1 = this.fromDate
    this.fromDate = getDate1.getFullYear() + "-" + ("0" + (getDate1.getMonth() + 1)).slice(-2) + "-" + ("0" + (getDate1.getDate())).slice(-2)
    let getDate2 = this.toDate
    this.toDate = getDate2.getFullYear() + "-" + ("0" + (getDate2.getMonth() + 1)).slice(-2) + "-" + ("0" + (getDate2.getDate())).slice(-2)

    this.optionsMulti2 = {
      pickMode: 'multi',
      weekdays: [this.addCall.title411, this.addCall.title412, this.addCall.title413, this.addCall.title414, this.addCall.title415, this.addCall.title416, this.addCall.title417],
      from: new Date(this.fromDate),
      to: new Date(this.toDate),
    }

    getMonthDifference(new Date(), new Date(this.fromDate))

    function getMonthDifference(startDate, endDate) {
      let monthdiff = endDate.getMonth() - startDate.getMonth() + 12 * (endDate.getFullYear() - startDate.getFullYear())

      for (let i = 1; i <= monthdiff; i++) {
        setTimeout(() => {
          $(".forward").trigger("click");
        }, 1000);
      }
    }

    if (this.fromDate != null) {
      this.frmDateAlert = false
    }
    if (this.toDate != null) {
      this.toDateAlert = false
    }
  }

  timeValidation() {
    if (!this.getFromTime) {
      this.getToTime = "";
      return;
    }

    this.getFromTime1 = this.getFromTime;
    let tTime = this.getFromTime.split(":");
    let hours = parseInt(tTime[0]);
    let minutes = parseInt(tTime[1]);
    let tTym = new Date();
    tTym.setHours(hours);
    tTym.setMinutes(minutes);

    if (this.particularNurseBook[0].eightHour === 'true' || this.workingHours !== '24:00') {
      tTym.setTime(tTym.getTime() + 43200000); // Adding 12 hours
    } else {
      tTym.setTime(tTym.getTime() + 86400000); // Adding 24 hours
    }

    let getToHours = tTym.getHours();
    let getToMinutes = tTym.getMinutes();

    this.getToTime = `${this.formatTimePart(getToHours)}:${this.formatTimePart(getToMinutes)}`;
    this.getToTime1 = this.getToTime;
    if (this.getFromTime) {
      this.frmTimeAlert = false;
    }
  }

  formatTimePart(timePart: number): string {
    return (timePart < 10 ? '0' : '') + timePart;
  }
  dynamicFromTime() {
    this.getFromTime = new Date(this.getFromTime).toString()
    this.getFromTime1 = this.getFromTime.split(" ")[4]
    let tTym = new Date(this.getFromTime)

    if (this.particularNurseBook[0].eightHour == 'true' || this.workingHours !== '12:00') {
      tTym.setTime(tTym.getTime() + 28800000)
    } else {
      tTym.setTime(tTym.getTime() + 43200000)
    }
    this.getToTime = tTym.toString()
    this.getToTime1 = this.getToTime.split(" ")[4]

    if (this.getFromTime != null) {
      this.frmTimeAlert = false
    }
  }

  async backToNursingPage() {
    debugger;
    this.showcoment = false;
    this.dutyofMin = false;
    this.isShow = !this.isShow
    this.excludeDates = null;
    this.dateCount = null;
    this.steddate = null;

    if (localStorage.getItem("NopayGoBack") == "reschedulePage") {
      localStorage.setItem("GoBackToNursBooked", "rescheduleNurseList")
      this.router.navigate(['/tabs/nurse-booking'])
      this.dutyArray = []
    } else if (localStorage.getItem("NopayGoBack") == "repeatPage") {
      this.ChangeEventNurse.emit("isNurseBackRepeatToHistory");
      this.presentView = "";
      this.showcoment = false;
      localStorage.setItem("GoBackToNursBooked", "repeatNurseList")
      // this.router.navigate(['/tabs/nurse-booking'])
      this.dutyArray = [];
      this.nurseBookingProfile = false;
      this.fromResch = true;
      this.fromRepeat = false;
      this.excludeDates = null;
    } else if (localStorage.getItem("NopayGoBack") == "editdesign") {
      localStorage.setItem("GoBackToNursBooked", "particularBookingDetails")
      localStorage.setItem("NurseViewBookingId", this.nurseBookingId)
      this.ChangeEventNurse.emit('particularBookingDetails');
      // this.router.navigate(['/tabs/nurse-booking', { nursebooking: this.nurseBookingId }])
      this.dutyArray = [];
      this.addSomething = [];
      this.excludeDates = null;
    }

    else {
      this.executed = true
      this.addSomething = []
      this.presentView = "nursingPage"
      this.nursingPage = true
      this.nurseBookingProfile = false
      this.bookingConfim = false
      this.nurseProfileDetails = false
      this.mapPage = false
      await this.getNurseList(12)
      await this.patientNurseSearch()

    }
  }

  addChip() {
    if (this.addDuties.length != 0) {
      let arabicWords;
      if (this.addDuties.replace(/\s/g, '').length > 2) {
        let arabicWordPattern = /^[\u0600-\u06FF0-9\s]+$/;
        arabicWords = arabicWordPattern.test(this.addDuties)
      }

      const validPattern = /^[a-zA-Z0-9\s]+$/
      let valid = false;
      if (validPattern.test(this.addDuties)) {
        this.validation = this.addDuties.trim().replace(/[^a-zA-Z]/g, '').length
        valid = true;
      }

      if (this.validation > 4 && valid == true || arabicWords) {
        this.dutyAlert = false
        this.dutyofMin = false;
        this.addLabel = true;
        if (this.added_duties.some(item => item.dutyname == this.addDuties) == false) {
          this.added_duties.push({ dutyname: this.addDuties })
        }

        if (this.addSomething.some(d => d.dutyname == this.addDuties) == false) {
          this.addSomething.push({
            dutyname: this.addDuties,
            selected: true
          })
        }
        this.chipshow = true;
        this.addDuties = ''

      } else {
        this.dutyofMin = true;
        this.dutyAlert = false
      }
    }
    // this.addDuties = ''
    this.tempDutyArray = this.added_duties;
  }
  datalength() {
    if (this.addDuties.length > 4) {
      this.dutyofMin = false;
      // this.dutyAlert = false
    }
  }

  clickChip(index) {
    this.addSomething[index].selected = !this.addSomething[index].selected
  }
  dutiesdeleted: any = [];
  delChip(i, duties, checkduties) {
    console.log("itemm", i);

    if (checkduties == 1) {
      let showdelete = this.showduty.splice(this.showduty.findIndex(item => item.dutyname == duties), 1,)
      this.deletedata.push(showdelete[0])
      this.dutiesdeleted.push(showdelete[0])
    }
    else if (checkduties == 2) {
      this.added_duties.splice(this.added_duties.indexOf(duties), 1,)
    }
  }

  removechip(item) {
    this.addSomething = this.addSomething.filter(obj => obj.dutyname !== item.dutyname);
  }

  async presentToast(msg) {
    const toast = await this.toastCtrl.create({
      message: msg,
      duration: 2000,
      cssClass: 'toastStyle',
    });
    toast.present();
  }
  async updateDduties() {
    if (this.added_duties.length != 0 || this.showduty.length != 0) {
      if (this.added_duties.length > 0 || this.deletedata.length > 0) {
        this.dutyofMin = false;
        const loading = await this.loadingCtrl.create({
          message: 'Please wait...',
        })
        await loading.present()
        let apidata = JSON.stringify({
          "patientid": this.currentMemberId,
          "nurseid": this.particullarnurseid,
          "designduties": this.added_duties,
          "deleteddutyid": this.dutiesdeleted,
          "nursebookingid": this.nurseBookingId,
        })
        this.services.postRequest('updatedesignduties', apidata).subscribe(async response => {
          await loading.dismiss();
          if (response.data[0].ErroeCode == 9999) {
            this.Alertpopup(this.addCall.title473, 3, "")
          }
        })
      }
    } else {
      this.presentToast(this.addCall.title654)
    }
  }

  finalpage: any;
  openBooking(frm) {
    debugger;
    console.log(this.particularNurseBook[0], 'particularNurseBook[0]');

    this.showcoment = false;
    this.finalpage = frm;
    this.timeValidation()
    this.designedDuties = null
    this.confirmloc = false

    let i = 1
    for (let item of this.addSomething) {
      if (frm == "repeat") {
        if (this.designedDuties) {
          this.designedDuties += ", " + item.dutyname
        } else {
          this.designedDuties = item.dutyname
        }
      } else {
        if (item.selected == true) {
          this.dutyCount = i++
          if (this.dutyCount < 2) {
            if (this.designedDuties) {
              this.designedDuties += ", " + item.dutyname
            } else {
              this.designedDuties = item.dutyname
            }
          }
        }
      }
    }
    if (this.designedDuties == null) {

      if (this.dutyofMin == true) {
        this.dutyAlert = false;
      } else {
        this.dutyAlert = true;
      }
      document.getElementById("designDuties").focus()
    }

    const arabicWordPattern = /[\u0600-\u06FF\u0750-\u077F]+/g;
    const arabicWords = this.designedDuties?.match(arabicWordPattern);
    this.validation = this.designedDuties?.trim().replace(/[^a-zA-Z]/g, '').length

    if (this.designedDuties != null && this.validation > 4 || arabicWords && this.fromDate != "" && this.toDate != "" && this.getFromTime != "" && this.getToTime != "") {
      if (this.getFromTime != "Invalid Date" && this.getFromTime != "") {
        this.getPatientProfile()
        if (frm == "repeat") {
          this.presentView = "bookingConfirmRepeat";
        } else {
          this.presentView = "bookingConfim";
        }
        this.dutyArray = JSON.parse(JSON.stringify(this.addSomething));
        this.bookingConfim = true
        this.nursingPage = false
        this.nurseBookingProfile = false
        this.nurseProfileDetails = false
        this.mapPage = false
      } else if (this.getFromTime == "Invalid Date" || this.getFromTime == "") {
        this.getFromTime = "";
        this.getToTime = "";
        this.presentToast(localStorage.getItem("selectedLanguage") === "en" ? "Please Select Start time.!" : "الرجاء تحديد وقت البدء.!")
      }
    }
    if (this.designedDuties == null) {
      this.dutyAlert = true
      document.getElementById("designDuties").focus()
    } if (this.designedDuties != null && this.validation > 4 || arabicWords) {
      this.dutyAlert = false;
      this.dutyofMin = false;
    }
    if (this.fromDate == "") {
      this.frmDateAlert = true
      document.getElementById("designDuties2").focus()
    }

    if (this.getFromTime == "") {
      this.frmTimeAlert = true
    }
  }


  openmap() {
    setTimeout(() => {
      this.loadmap()
    }, 1000)
    this.confirmloc = true
    this.presentView = "maptab"
    this.mapPage = true
    this.bookingConfim = false
    this.nursingPage = false
    this.nurseBookingProfile = false
    this.nurseProfileDetails = false
  }
  async backToBooking(value) {
    if (value == 1) {
      let message = ``
      this.Alertpopup(message, 4, "")
    }

    this.presentView = "bookingConfim"
    this.mapPage = false
    this.nurseBookingProfile = false
    this.nursingPage = false
    this.bookingConfim = true
    this.nurseProfileDetails = false
  }

  backToNurseProfile() {
    debugger;
    if (this.presentView == "bookingConfirmRepeat") {
      this.presentView = "nurseProfileDetails";
    } else {
      this.presentView = "nurseBookingProfile";
    }
    this.nurseBookingProfile = true
    this.nursingPage = false
    this.bookingConfim = false
    this.nurseProfileDetails = false
    this.mapPage = false
    this.isConfirmed = false;
    this.address = "";
  }

  rescheduleIt() {
    if (this.fromDate != "" && this.toDate != "" && this.getFromTime != "" && this.getToTime != "") {
      this.patientNurseBookingReschedule()
      this.frmDateAlert = false
      this.frmTimeAlert = false
      this.toTimeAlert = false
    } else if (this.fromDate == "") {
      this.rescheduleToast("Choose From Date")
    } else if (this.toDate == "") {
      this.rescheduleToast("Choose To Date")
    } else if (this.getFromTime == "") {
      this.rescheduleToast("Choose From Time")
    } else if (this.getToTime == "") {
      this.rescheduleToast("Choose To Time")
    }
  }

  repeatBooking() {
    debugger
    this.showcoment = false;
    if (this.fromDate != null && this.toDate != null && this.getFromTime != null && this.getToTime != null) {
      console.log(this.fromDate, "fromDate");

    } else if (this.fromDate == null) {
      this.rescheduleToast("Choose From Date")
      this.frmDateAlert = true
    } else if (this.toDate == null) {
      this.rescheduleToast("Choose To Date")
    } else if (this.getFromTime == null && this.getFromTime == "") {
      this.rescheduleToast("Choose From Time")
      this.frmTimeAlert = true
    } else if (this.getToTime == null && this.getToTime == "") {
      this.rescheduleToast("Choose To Time")
      this.toTimeAlert = true
    }
    if (this.designedDuties == null) {
      this.dutyAlert = true
      document.getElementById("designDuties").focus()
    } if (this.designedDuties != null) {
      this.dutyAlert = false
    }
    this.openBooking('repeat')
  }

  selectMember(value, membId, phone_no) {
    this.tempMemberName = value;
    this.currentMemberId = membId;
    this.Phoneno = phone_no;
  }

  uploadPhoto() {
    this.fileupload.getFiles("2").then(async data => {
      if (data[0] == "0") {
        const toast = await this.toastController.create({
          message: data[1],
          duration: 2000
        })
        toast.present()
      } else {
        console.log(data[0])

      }
    })
  }
  paymentid: any;
  referenceid: any;
  order_Id: any;
  paymentGatewayName: any;
  async goToPayment() {
    debugger
    if (this.address == "" || this.address == undefined) {
      this.rescheduleToast("Address Required");
    } else if (this.confirmloc == false ) {
      let message = ``
      this.Alertpopup(message, 4, "")
    } else {
      if (this.presentView == "bookingConfirmRepeat") {
        this.tempDutyArray = this.addSomething;
      } else {
        this.dutyArray = this.dutyArray.filter((item) => item.selected == true)
        this.tempDutyArray = JSON.parse(JSON.stringify(this.dutyArray))
        for (let item of this.tempDutyArray) {
          delete item["selected"]
        }
      }
      await this.presentModal1();
    }
  }

  gatewayFunction(res: any, paymentGateway: any) {
    if (res.status == "1") {
      debugger;
      this.payload = JSON.parse(localStorage.getItem("requestdata"))
      this.payload.paymentid = res.paymentId;
      this.payload.referenceid = res.referrence;
      this.payload.orderid = res.orderId;
      this.payload.paymentGateway = res.paymentGatewayName;
      this.payload.payment_gateway_id=res.paymentGatewayId
      // this.paymentid = res.paymentId;
      // this.referenceid = res.sessionid;
      // this.order_Id = res.orderId;
      // this.paymentGatewayName = res.paymentGatewayName;
      this.patientNurseBooking("", res);
    }
    else if (res.status == "2") {
      this.Alertpopup(this.addCall.title144, 0, "")
    }
    else if (paymentGateway == "Knet") {
      debugger
      this.showKnetPaymentDetals(res, this.addCall.title655);
    } else {
      this.Alertpopup(this.addCall.title144, 0, "")
    }
  }

  async patientNurseBooking(frmpage, response) {
    debugger
    if (this.nurseBookReq) {
      this.nurseBookReq.unsubscribe()
    }

    const loading = await this.loadingCtrl.create({
      message: 'Processing Your Payment Status',
    })
    await loading.present()
    // this.paymentid = "" // res.resultid;
    // this.referenceid = "" // res.sessionid;
    // this.order_Id = "" // res.orderId;
    // this.paymentGatewayName = "" // res.paymentGatewayName;
    // let requestdata = JSON.stringify({
    //   "nurseId": this.nurseId,
    //   "designedDuties": this.tempDutyArray,
    //   "excludeDate": this.myDates2,
    //   "isMember": isMember,
    //   "tempMemberName": this.tempMemberName,
    //   "fromDate": this.fromDate,
    //   "toDate": this.toDate,
    //   "patientId": localStorage.getItem("patient_id"),
    //   "nurseVendorId": this.nurseVendorId,
    //   "fromTime": this.getFromTime,
    //   "toTime": this.getToTime,
    //   "workingHours": this.workingHours,
    //   "bookedDate": this.today,
    //   "amount": this.price_per_day,
    //   "finalamount": this.total_price_per_day,
    //   "deal": this.dealVal,
    //   "dealId": this.dealId,
    //   "dealoption": this.dealOptn,
    //   "paymentStatus": "1",
    //   "latitude": this.latitude,
    //   "longitude": this.longitude,
    //   "address": this.address,
    //   "paymentid": this.paymentid,
    //   "referenceid": this.referenceid,
    //   "orderid": this.order_Id,
    //   "paymentGateway": this.paymentGatewayName,
    //   "walk_in": this.routeId,
    // })
    let data = JSON.stringify(this.payload)
    this.nurseBookReq = this.services.postRequest("patientNurseBooking", data).subscribe(async res => {
      await loading.dismiss()
      this.playSound();
      if (res.status == 1) {
        localStorage.setItem("payBack", "nursing");
        if (localStorage.getItem("cardType") == "Knet") {
          this.showKnetPaymentDetals(response, this.addCall.title620);
        }
        else if (localStorage.getItem("cardType") == "MasterCard") {
          // this.router.navigate(['/payment', { paymentstatus: 1 }]);
          this.presentView = "paid"
        }
        this.nurseBookingProfile = false
        this.nursingPage = false
        this.bookingConfim = false
        this.nurseProfileDetails = false
        this.mapPage = false
        this.nursingPage = false
        this.nurseBookingProfile = false
        this.nurseProfileDetails = false
      } else {
        if (frmpage === 'repeat') {
          this.Alertpopup(res.msg, res.status, "frmrep")
        }
        else {
          this.Alertpopup(res.msg, res.status, "")
        }
      }
      this.localClear();
    })
  }

  playSound() {
    let audio = new Audio();
    audio.src = "../assets/audio/tick.mp3";
    audio.load();
    audio.play();
  }

  openNurseDetails(item: any) {
    this.presentView = "nurseProfileDetails"
    this.nurseProfileDetails = true
    this.nursingPage = false
    this.nurseBookingProfile = false
    this.bookingConfim = false
    this.mapPage = false
    this.particularProfile = item
    this.reviewcomment = JSON.parse(this.particularProfile.review_comments)
  }

  backToNursProfile() {
    if (localStorage.getItem("NopayGoBack") == "nursedetails") {
      localStorage.setItem("GoBackToNursBooked", "rescheduleNurseList")
      this.router.navigate(['/tabs/nurse-booking'])
      this.dutyArray = []
    }
    else if (localStorage.getItem("NopayGoBack") == "nursedetailshistory") {
      localStorage.setItem("GoBackToNursBooked", "repeatNurseList")
      this.router.navigate(['/tabs/nurse-booking'])
      this.dutyArray = []
      this.excludeDates = null;
    }
    else {
      this.presentView = "nursingPage"
      this.nursingPage = true
      this.nurseBookingProfile = false
      this.bookingConfim = false
      this.nurseProfileDetails = false
      this.mapPage = false
    }
  }

  openBookingHis() {
    localStorage.setItem("GoBackToNursBooked", "fromNurseSearchList");
    this.nurseDudtyUpdate.emit({ patientId: localStorage.getItem("patient_id") });
    this.nursingPage = false
    this.nurseBookingProfile = false
    this.bookingConfim = false
    this.nurseProfileDetails = false
    this.mapPage = false
  }

  openFilter() {
    this.advFilter = true
    this.costRange1 = this.costRange
  }
  closeAdvFilter() {
    this.advFilter = false
  }

  async costSort() {
    this.ratingSorting = false
    this.costSorting = true
    this.experienceSorting = false
    this.ageSorting = false
    if (this.costBasedSortingOrder == "ASC") {
      this.costBasedSortingOrder = "DESC"
    } else if (this.costBasedSortingOrder == "DESC") {
      this.costBasedSortingOrder = "ASC"
    }
    let timeDifference = this.endDate1 - this.startDate1;
    this.dayDifference = (timeDifference / (1000 * 3600 * 24)) + 1;
    if (this.dayDifference >= 7) {
      await this.getNurseList(2)
      await this.patientNurseSearch()

    }
  }

  async experienceSort() {
    this.ratingSorting = false
    this.experienceSorting = true
    this.costSorting = false
    this.ageSorting = false
    if (this.expBasedSortingOrder == "ASC") {
      this.expBasedSortingOrder = "DESC"
    } else if (this.expBasedSortingOrder == "DESC") {
      this.expBasedSortingOrder = "ASC"
    }
    let timeDifference = this.endDate1 - this.startDate1;
    this.dayDifference = (timeDifference / (1000 * 3600 * 24)) + 1;
    if (this.dayDifference >= 7) {
      await this.getNurseList(3)
      await this.patientNurseSearch()

    }
  }

  async ageSort() {
    this.ratingSorting = false
    this.ageSorting = true
    this.costSorting = false
    this.experienceSorting = false
    if (this.ageBasedSortingOrder == "ASC") {
      this.ageBasedSortingOrder = "DESC"
    } else if (this.ageBasedSortingOrder == "DESC") {
      this.ageBasedSortingOrder = "ASC"
    }
    let timeDifference = this.endDate1 - this.startDate1;
    this.dayDifference = (timeDifference / (1000 * 3600 * 24)) + 1;
    if (this.dayDifference >= 7) {
      await this.getNurseList(4)
      await this.patientNurseSearch()

    }
  }

  async ratingSort() {
    this.ageSorting = false
    this.costSorting = false
    this.experienceSorting = false
    this.ratingSorting = true
    if (this.ratingBasedSortingOrder == "ASC") {
      this.ratingBasedSortingOrder = "DESC"
    }
    else if (this.ratingBasedSortingOrder == "DESC") {
      this.ratingBasedSortingOrder = "ASC"
    }
    let timeDifference = this.endDate1 - this.startDate1;
    this.dayDifference = (timeDifference / (1000 * 3600 * 24)) + 1;
    if (this.dayDifference >= 7) {
      await this.getNurseList(4)
      await this.patientNurseSearch()

    }
  }

  frm: any;
  async costFilter(event: any, frm) {
    if (this.executed == false && frm == this.frm) {
      this.costStatus = true
      this.costRange1 = this.costRange
      let timeDifference = this.endDate1 - this.startDate1;
      this.dayDifference = (timeDifference / (1000 * 3600 * 24)) + 1;
      if (this.dayDifference >= 7) {
        await this.getNurseList(5)
        await this.patientNurseSearch()

      }
    }
    this.frm = 1
  }
  async selectGender() {
    this.genderStatus = true
    let timeDifference = this.endDate1 - this.startDate1;
    this.dayDifference = (timeDifference / (1000 * 3600 * 24)) + 1;
    if (this.dayDifference >= 7) {
      await this.getNurseList(6)
      await this.patientNurseSearch()

    }

  }
  costFilter1() {
    this.costStatus = true
  }
  expFilter() {
    this.expStatus = true
  }
  ratingFilter() {
    this.ratingStatus = true
  }
  async selectNationality() {
    this.natStatus = true
    let timeDifference = this.endDate1 - this.startDate1;
    this.dayDifference = (timeDifference / (1000 * 3600 * 24)) + 1;
    if (this.dayDifference >= 7) {
      await this.getNurseList(13)
      await this.patientNurseSearch()

    }


  }
  async searchIt() {
    this.costStatus = true
    this.advFilter = false
    this.costRange = this.costRange1
    await this.getNurseList(7)
    await this.patientNurseSearch()

  }
  async searchInput() {
    if (this.searchContent != null) {
      this.typeSearch = true
      await this.getNurseList(8)
      await this.patientNurseSearch()

    }
  }

  async toggleChanges() {

    let timeDifference = this.endDate1 - this.startDate1;
    this.dayDifference = (timeDifference / (1000 * 3600 * 24)) + 1;

    if (this.dayDifference >= 7) {
      if (this.executed == false) {
        if (this.toggleModel == true) {
          this.toggleModel1 = true
        } else {
          this.toggleModel1 = false
        }
        await this.getNurseList(11)
        await this.patientNurseSearch()

      }
    }



  }

  fromDateToDate() {
    // let timeDifference = this.endDate - this.startDate;
    const startDate = new Date(this.startDate);
    const endDate = new Date(this.endDate);
    const timeDifference = endDate.getTime() - startDate.getTime();
    const dayDifference = timeDifference / (1000 * 3600 * 24);
    const totalDays= Math.round(dayDifference);
    this.dayDifference = totalDays
    if (this.dayDifference >= 7) {
      if (this.fromDate != null) {
        this.dateFilter = true
        this.rangeFromDate = this.fromDate
      }
      else {
        this.rangeFromDate = this.fromDate
      }
    } else {
      this.toDate_validation = true
      // this.presentToast("To date should be greater than from date");
      this.patNurseSearch = []
    }
  }

  async setToDate() {
    this.oldtoDate = this.rangeToDate
    this.rangeToDate = this.toDate
    this.rangeToDate = new Date(this.rangeToDate);
    this.rangeFromDate = new Date(this.rangeFromDate);
    // Log the converted dates
    console.log("Converted rangeToDate", this.rangeToDate);
    console.log("Converted rangeFromDate", this.rangeFromDate);
    if (isNaN(this.rangeToDate.getTime()) || isNaN(this.rangeFromDate.getTime())) {
    } else {
      const parseDate = (dateStr, locale) => {
        const [day, monthName, year] = dateStr.split('-');
        const dateFormatter = new Intl.DateTimeFormat(locale, { month: 'long' });
        const months = [];
        for (let i = 0; i < 12; i++) {
          const month = dateFormatter.format(new Date(2024, i, 1));
          months.push(month);
        }
        const monthIndex = months.findIndex(month => month === monthName.trim());
        if (monthIndex === -1) {
          throw new Error(`Invalid month name: ${monthName}`);
        }
        return new Date(year, monthIndex, day);
      };

      if (this.addCall.selectedLanguage == 'ea') {
        const dateStr = this.rangeToDate;
        const date = Date.parse(dateStr) ? new Date(Date.parse(dateStr)) : new Date(); // Fallback to current date if parsing fails
        const day = String(date.getDate()).padStart(2, '0');
        const year = String(date.getFullYear()).slice(2);
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = monthNames[date.getMonth()];
        // Format the date as 30-24-Nov
        const formattedDate = `${day}-${year}-${month}`;
        this.endDateCalendar = formattedDate;

        // Use reliable date formatting for Arabic locale (ensure that `parseDate` handles it well)
        this.startDate1 = parseDate(this.startDate, 'ar-EG');
        this.endDate1 = parseDate(this.endDate, 'ar-EG');
      } else {
        // For other cases, ensure that the dates are parsed in a consistent manner
        this.startDate1 = Date.parse(this.startDate) ? new Date(Date.parse(this.startDate)) : new Date();
        this.endDate1 = Date.parse(this.endDate) ? new Date(Date.parse(this.endDate)) : new Date();
        this.endDateCalendar = this.endDate;
      }

      let timeDifference = this.endDate1 - this.startDate1;
      this.dayDifference = (timeDifference / (1000 * 3600 * 24)) + 1;

      if (this.dayDifference >= 7) {
        await this.getNurseList(14)
        await this.patientNurseSearch()

        this.toDate_validation = false
      } else {
        this.presentToast(localStorage.getItem("selectedLanguage") === "en" ? "please select 7 days nurse" : "يرجى اختيار ممرضة 7 أيام")
        // this.patNurseSearch = [];
        this.endDate = moment(this.oldtoDate).format("DD-MMM-YY");
      }

      if (this.dayDifference >= 30) {
        this.dateCalculation = localStorage.getItem("selectedLanguage") === 'en' ? "Month" : "شهر";
      } else {
        this.dateCalculation = localStorage.getItem("selectedLanguage") === 'en' ? "Day" : "يوم";
      }
    }
  }

  async repeatDynamicFrmTime() {
    this.getFromTime = new Date(this.getFromTime).toString()
    if (this.getFromTime != null) {
      this.frmTimeAlert = false
    }
    await this.getNurseList(11)
    await this.patientNurseSearch()

  }

  async repeatDynamicToTime() {
    this.getToTime = new Date(this.getToTime).toString()
    if (this.getToTime != null) {
      this.toTimeAlert = false
    }
    await this.getNurseList(11)
    await this.patientNurseSearch()

    
  }

  async getNurseList(value) {
    this.pageno1 = 1
    this.lastNurseId = 0
    this.patNurseSearch = []
    this.skeletonLoad = null
    // this.patientNurseSearch()
  }

  loadData1(event: any) {
    this.scrollEvent = event
    if (this.nextCount == 0) {
      event.target.disabled = true
    } else {
      this.pageno1 += 1
      let timeDifference = this.endDate1 - this.startDate1;
      this.dayDifference = (timeDifference / (1000 * 3600 * 24)) + 1;
      if (this.dayDifference >= 7) {
        this.patientNurseSearch()
      }
    }
  }

  updatedResponse(response: any) {
    return {
      ...response,
      data: response.data.map((group: any) => ({
        ...group,
        details: group.details.map((item: any) => {
          let updatedDealDetails: any[] = [];

          if (item.dealsDetails != null) {
            try {
              updatedDealDetails = JSON.parse(item.dealsDetails);
            } catch (error) {
              console.error(`Error parsing dealsDetails for NurseId ${item.NurseId}:`, error);
            }
          }

          return {
            ...item,
            dealsDetails: updatedDealDetails
          };
        })
      }))
    };
  };
  //API Integration --------------------------
  async patientNurseSearch() {
    this.reviewCmt = [];
    this.reviewCommand = [];
    this.skeletonLoad = null
    if (this.searchRequest) {
      this.searchRequest.unsubscribe()
    }
    let dateNow = new Date().toISOString().split("T")[0];
    this.rangeFromDate = moment(this.startDate).format("YYYY-MM-DD") //new Date(this.startDate).toISOString().split("T")[0];
    this.rangeToDate = moment(this.endDate).format("YYYY-MM-DD") //new Date(this.endDate).toISOString().split("T")[0];
    let requestdata = JSON.stringify({
      "pageno": this.pageno1,
      "limit": "15",
      "expBasedSorting": this.experienceSorting,
      "costBasedSorting": this.costSorting,
      "ageBasedSorting": this.ageSorting,
      "ratingBasedSorting": this.ratingSorting,
      "typeSearch": this.typeSearch,
      "costFilter": this.costStatus,
      "experienceFilter": this.expStatus,
      "nationalityFilter": this.natStatus,
      "genderFilter": this.genderStatus,
      "dateFilter": this.dateFilter,
      "searchContent": this.searchContent,
      "eightHour": this.toggleModel1,
      "minCost": this.minCost,
      "maxCost": this.costRange,
      "minExp": this.minExp,
      "maxExp": this.expRange,
      "minRating": this.minRating,
      "MaxRating": this.rateingRange,
      "nationalityId": this.chooseNationality,
      "gender": this.chooseGender,
      "fromDate": this.rangeFromDate,
      "toDate": this.rangeToDate,
      "ageBasedSortingOrder": this.ageBasedSortingOrder,
      "costBasedSortingOrder": this.costBasedSortingOrder,
      "expBasedSortingOrder": this.expBasedSortingOrder,
      "ratingBasedSortingOrder": this.ratingBasedSortingOrder,
      "currentDate": dateNow,
      "patientid": localStorage.getItem("patient_id"),
      "lastId": this.lastNurseId,
      "vendorId": this.vendorId
    })
    // await this.getWalkinMemberDetails();
    // this.searchRequest = this.services.postRequest("patientNurseSearch1", requestdata).subscribe(response => {
    this.searchRequest = this.services.postRequest("patientNurseSearch_walkin", requestdata).subscribe(response => {

      if (response.data.length > 0) {
        response = this.updatedResponse(response);
        this.particularNurseBook = response.data[0].details;
        this.lastNurseId = response.data[0].details[response.data[0].details.length - 1].NurseId;
      }

      const parseDate = (dateStr, locale) => {
        const [day, monthName, year] = dateStr.split('-');
        const dateFormatter = new Intl.DateTimeFormat(locale, { month: 'long' });
        const months = [];
        for (let i = 0; i < 12; i++) {
          const month = dateFormatter.format(new Date(2024, i, 1));
          months.push(month);
        }

        const monthIndex = months.findIndex(month => month === monthName.trim());
        if (monthIndex === -1) {
          throw new Error(`Invalid month name: ${monthName}`);
        }
        return new Date(year, monthIndex, day);
      };

      if (this.addCall.selectedLanguage == 'ea') {
        this.startDate1 = parseDate(this.startDate, 'ar-EG'); // Arabic locale
        this.endDate1 = parseDate(this.endDate, 'ar-EG');
      } else {
        this.startDate1 = new Date(this.startDate); // Assuming English format
        this.endDate1 = new Date(this.endDate);
      }

      let timeDifference = this.endDate1 - this.startDate1;
      this.dayDifference = (timeDifference / (1000 * 3600 * 24)) + 1;
      let fullMonths = Math.floor(this.dayDifference / 30);
      let remainingDays = this.dayDifference % 30;
      let displayValue;
      displayValue = `${this.dayDifference} day${this.dayDifference > 1 ? 's' : ''}`;
      this.displayValue = displayValue;

      if (this.dayDifference >= 30) {
        this.dateCalculation = localStorage.getItem("selectedLanguage") === 'en' ? "Month" : "شهر";
      } else {
        this.dateCalculation = localStorage.getItem("selectedLanguage") === 'en' ? "Day" : "يوم";
      }

      if (this.refEvent) {
        this.refEvent.target.complete()
      }
      if (this.scrollEvent) {
        this.scrollEvent.target.complete()
      }
      if (this.pageno1 == 1) {
        this.skeletonLoad = response.status
      }
      this.eighthrs = response.eightHour
      this.executed = false

      if (response.data.length > 0) {
        for (let item of response.data[0].details) {
          this.patNurseSearch.push(item)
        }
        this.nextCount = response.data[0].details[0].nextCount;
        if (this.nurseId != "" && this.nurseId != undefined && this.nurseId.length != 0) {
          this.patNurseSearchforblock = [];
          this.patNurseSearch.push(response.data[0].details)
        }
      } else {
        this.nextCount = 0;
      }

    })

    console.log("cccccccccccccccccccccccccc", this.patNurseSearch);


    console.log("kkkkkkkkkkkk", this.particularNurseBook);

  }

  async minMaxCostForNurse() {
    if (this.costReq) {
      this.costReq.unsubscribe()
    }
    let requestdata = JSON.stringify({
      "vendoid" : this.vendorId
    })
    this.costReq = this.services.postRequest("minMaxCostForNurse", requestdata).subscribe(async response => {
      this.minMaxCost = response.data
      this.minCost = response.data[0].minCost
      this.maxCost = response.data[0].maxCost
      this.costRange = this.maxCost
      this.costRange1 = this.maxCost
      await this.patientNurseSearch()

    })
  }

  async minMaxExperienceForNurse() {
    if (this.minMaxExpReq) {
      this.minMaxExpReq.unsubscribe()
    }
    let requestdata = JSON.stringify({
      "vendoid" : this.vendorId
    })
    this.minMaxExpReq = this.services.postRequest("minMaxExperienceForNurse", requestdata).subscribe(response => {
      this.minMaxExperience = response.data
      this.minExp = response.data[0].minExp
      this.maxExp = response.data[0].maxExp
      this.expRange = this.maxExp
    })
  }

  minMaxRatingForNursing() {
    if (this.minmaxRating) {
      this.minmaxRating.unsubscribe()
    }
    let requestdata = JSON.stringify({
    })
    this.minmaxRating = this.services.postRequest("minMaxRatingForNursing", requestdata).subscribe(response => {
      this.minMaxRating = response.data
      this.minRating = response.data[0].minRating
      this.maxRating = response.data[0].maxRating
      this.rateingRange = this.maxRating
    })
  }

  async getNationalityForNurse() {

    if (this.getNationReq) {
      this.getNationReq.unsubscribe()
    }
    let requestdata = JSON.stringify({
      "vendoid" : this.vendorId
    })
    this.getNationReq = this.services.postRequest("getNationalityForNurse", requestdata).subscribe(response => {
      this.nationalityForNurse = response.data
    }, err => {
    })
  }
  myaddress: any
  Email: any;
  Phoneno: any;

  getPatientProfile() {
    if (this.patProReq) {
      this.patProReq.unsubscribe()
    }
    this.today2 = new Date().toJSON().split("T")[0]
    let curDate1 = new Date().toTimeString()?.split("T")[0]?.split(" ")[0]?.split(":")[0]
    let curDate2 = new Date().toTimeString()?.split("T")[0]?.split(" ")[0]?.split(":")[1]
    this.currentTime = curDate1 + ":" + curDate2

    let requestdata = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "currentDate": this.today2,
      "currentTime": this.currentTime,
    })
    this.patProReq = this.services.postRequest("getPatientProfile", requestdata).subscribe(response => {
      // this.PatientProfile = response.data[0]
      // this.MyName = response.data[0].name
      // this.particularProfile = response.data[0].name;
      // this.tempMemberName = response.data[0].name;
      // this.currentMemberId = localStorage.getItem("patient_id");
      // this.Email = response.data[0].email;
      // this.Phoneno = response.data[0].phone_no;
    })
  }
  showduty: any = [];
  emptydata: any = [];

  particularBookingDetails() {
    debugger;
    // this.st_revcom = []
    this.emptydata = null;
    this.particularNurseBook = []
    this.added_duties = []
    this.showduty = []
    if (this.bookDetReq) {
      this.bookDetReq.unsubscribe()
    }
    let requestdata = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "nurseBookingId": this.nurseBookingId
    })
    this.bookDetReq = this.services.postRequest("particularBookingDetails", requestdata).subscribe(response => {
      debugger
      this.emptydata = response.status
      this.particularNurseBook = response.data;
      this.nurseId = response.data[0].nurse_id;
      this.nurseVendorId = response.data[0].nurse_vendor_id;
      this.workingHours = response.data[0].working_hours;
      this.amount = response.data[0].amount;
      this.dealVal = response.data[0].dealAmt;
      if (response.data[0].dealAmt == null) {
        this.dealVal = 0;
      }
      this.dealOptn = response.data[0]?.dealOption;
      this.finalAmt = response.data[0].final_amount;
      this.tempMemberName = response.data[0].patientName;
      this.nurseBookingId = response.data[0].nurseBookingId;
      this.isMember = response.data[0].is_member;
      this.frmRepetDsgnDuty = response.data[0].designedDuties.length;
      // this.particularnurse_revlike();

      for (let item of response.data) {
        for (let data of item.designedDuties) {
          this.dutyArray.push({
            dutyname: data.duties,
          })
          this.showduty.push({
            dutyname: data.duties,
            dutyid: data.nurseDutiesId,
            showCompletedDuties: data.showCompleted
          })
        }
        for (let d of item.old_duties) {
          this.deletedata.push({
            dutyname: d.duties,
            dutyid: d.nurseDutiesId
          })
        }
      }
      this.dtyArr = null

      for (let item of this.dutyArray) {
        if (this.dutyArray.length >= 0) {
          this.tempDutyArray = this.dutyArray;
          if (this.dtyArr) {
            this.dtyArr += ", " + item.dutyname
          } else {
            this.dtyArr = item.dutyname
          }
        }
      }

      if (localStorage.getItem("NopayGoBack") == "repeatPage") {
        if (response.msg == "Success") {
          this.getFromTime = (this.particularNurseBook[0].from_date?.split("T")[0]) + "T" + (this.particularNurseBook[0].from_time)
          this.getToTime = (this.particularNurseBook[0].to_date?.split("T")[0]) + "T" + (this.particularNurseBook[0].to_time)
          this.presentView = "nurseProfileDetails"
          this.nurseBookingProfile = true;
        }
      }
      else if (localStorage.getItem("NopayGoBack") == "editdesign") {
        this.presentView = "editdesign"
      }
      else {
        if (response.msg == "Success") {
          this.presentView = "nurseBookingProfile"
          this.nurseBookingProfile = true
          this.startDate = this.getFormattedDateTime(this.particularNurseBook[0].from_date, "Date1")
          this.fromDate = new Date(this.particularNurseBook[0].from_date?.split(" ")[0]).toISOString()?.split("T")[0]
          this.toDate = new Date(this.particularNurseBook[0].to_date?.split(" ")[0]).toISOString()?.split("T")[0]
          this.optionsMulti2 = {
            pickMode: 'multi',
            weekdays: [this.addCall.title411, this.addCall.title412, this.addCall.title413, this.addCall.title414, this.addCall.title415, this.addCall.title416, this.addCall.title417],
            from: this.startDate,
            to: this.endDate,
          }
          this.getFromTime = (this.particularNurseBook[0].from_date?.split("T")[0]) + "T" + (this.particularNurseBook[0].from_time)
          this.getFromTime1 = this.getFromTime?.split("T")[1]
          this.getToTime = (this.particularNurseBook[0].to_date?.split("T")[0]) + "T" + (this.particularNurseBook[0].to_time)
          this.getToTime1 = this.getToTime?.split("T")[1]

          if (response.data[0].excluded_date) {
            let dates = response.data[0].excluded_date?.split(",")
            this.dateRange = []
            for (let item of dates) {
            }
            this.myDates = response.data[0].excluded_date
          } else {
            this.dateRange = []
          }
        }
      }




      debugger
      const parseDate = (dateStr, locale) => {
        const [day, monthName, year] = dateStr.split('-');
        const dateFormatter = new Intl.DateTimeFormat(locale, { month: 'long' });
        const months = [];
        for (let i = 0; i < 12; i++) {
          const month = dateFormatter.format(new Date(2024, i, 1));
          months.push(month);
        }

        const monthIndex = months.findIndex(month => month === monthName.trim());
        if (monthIndex === -1) {
          throw new Error(`Invalid month name: ${monthName}`);
        }
        return new Date(year, monthIndex, day);
      };

      if (this.addCall.selectedLanguage == 'ea') {
        this.startDate1 = parseDate(this.startDate, 'ar-EG'); // Arabic locale
        this.endDate1 = parseDate(this.endDate, 'ar-EG');
      } else {
        this.startDate1 = new Date(this.startDate); // Assuming English format
        this.endDate1 = new Date(this.endDate);
      }
      let timeDifference = this.endDate1 - this.startDate1;
      this.dayDifference = (timeDifference / (1000 * 3600 * 24)) + 1;


      if (this.dayDifference >= 30) {
        this.dateCalculation = localStorage.getItem("selectedLanguage") === 'en' ? "Month" : "شهر";
      } else {
        this.dateCalculation = localStorage.getItem("selectedLanguage") === 'en' ? "Day" : "يوم";
      }
      // Calculate full months and remaining days
      let fullMonths = Math.floor(this.dayDifference / 30);
      let remainingDays = this.dayDifference % 30;
      debugger
      let displayValue;
      displayValue = `${this.dayDifference} day${this.dayDifference > 1 ? 's' : ''}`;
      this.displayValue = displayValue;
      this.addLabel = true;
      this.addDuties = this.particularNurseBook[0].designedDuties[0].duties;
      this.price_per_day = this.particularNurseBook[0].amount;
      this.dealVal = this.particularNurseBook[0].dealAmt;
      if (this.particularNurseBook[0].dealAmt == null) {
        this.dealVal = 0;
      }
      this.dealOptn = this.particularNurseBook[0]?.dealOption;
      this.total_price_per_day = this.particularNurseBook[0].final_amount;
      this.addSomething.push({ dutyname: this.particularNurseBook[0].designedDuties[0].duties });
      this.tempDutyArray = this.addSomething;
      if (this.addDuties.length != 0) {
        let arabicWords;
        if (this.addDuties.replace(/\s/g, '').length > 2) {
          let arabicWordPattern = /^[\u0600-\u06FF0-9\s]+$/;
          arabicWords = arabicWordPattern.test(this.addDuties)
        }

        const validPattern = /^[a-zA-Z0-9\s]+$/
        let valid = false;
        if (validPattern.test(this.addDuties)) {
          this.validation = this.addDuties.trim().replace(/[^a-zA-Z]/g, '').length
          valid = true;
        }

        if (this.validation > 4 && valid == true || arabicWords) {
          this.dutyAlert = false
          this.dutyofMin = false;
          this.addLabel = true;
          if (this.added_duties.some(item => item.dutyname == this.addDuties) == false) {
            this.added_duties.push({ dutyname: this.addDuties })
          }

          if (this.addSomething.some(d => d.dutyname == this.addDuties) == false) {
            this.addSomething.push({
              dutyname: this.addDuties,
              selected: true
            })
          }
        } else {
          this.dutyofMin = true;
          this.dutyAlert = false
        }
      }
      this.addDuties = ''
      this.tempDutyArray = this.added_duties;
      let i = 1
      for (let item of this.addSomething) {
        if (this.designedDuties) {
          this.designedDuties += ", " + item.dutyname
        } else {
          this.designedDuties = item.dutyname
        }
      }
      // if (this.designedDuties == null) {

      //   if (this.dutyofMin == true) {
      //     this.dutyAlert = false;
      //   } else {
      //     this.dutyAlert = true;
      //   }
      //   document.getElementById("designDuties").focus()
      // }
      if (this.particularNurseBook[0].excluded_date) {
        let dates = this.particularNurseBook[0].excluded_date?.split(",")
        this.dateRange = []
        for (let item of dates) {
        }
        this.myDates = this.particularNurseBook[0].excluded_date
      } else {
        this.dateRange = []
      }
    })
  }

  async patientNurseBookingReschedule() {
    if (this.nurseReschReq) {
      this.nurseReschReq.unsubscribe()
    }
    let bookedDate = new Date().toISOString()?.split("T")[0]
    if (this.myDates == null) {
      this.myDates = ""
    } else {
      this.myDates
    }
    if (this.reschedulePatientId == localStorage.getItem("patient_id")) {
      this.isMember = 0
    }
    else {
      this.isMember = 1
    }
    const loading = await this.loadingCtrl.create({
      message: 'Please wait...',
    })
    await loading.present()

    let requestdata = JSON.stringify({
      "oldBookingId": this.nurseBookingId,
      "patientId": localStorage.getItem("patient_id"),
      "nurseVendorId": this.nurseVendorId,
      "fromDate": this.fromDate,
      "toDate": this.toDate,
      "fromTime": this.getFromTime1,
      "toTime": this.getToTime1,
      "workingHours": this.workingHours,
      "bookedDate": bookedDate,
      "amount": String(this.amount),
      "paymentStatus": "1",
      "excludeDate": this.myDates2,
      "nurseId": this.nurseId,
      "isMember": this.isMember,
      "tempMemberName": this.tempMemberName,
      "designedDuties": this.dutyArray
    })
    this.nurseReschReq = this.services.postRequest("patientNurseBookingReschedule", requestdata).subscribe(async res => {
      await loading.dismiss()
      if (res.status == 1) {
        this.router.navigate(['/tabs/nurse-booking'])
        this.nursingPage = false
        this.nurseBookingProfile = false
        this.nurseProfileDetails = false
        this.Alertpopup(this.addCall.title474, res.status, "")
      } else {
        this.Alertpopup(res.msg, res.status, "")
      }
    }, err => {
    })
  }
  async Alertpopup(msg, status, is_rep) {

    const alert = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert',
      backdropDismiss: false,
      componentProps: {
        'msg': msg,
        'sts': status,
      }
    })
    await alert.present()
    alert.onDidDismiss().then((data) => {

      if (is_rep === 'frmrep') {
        localStorage.setItem("NopayGoBack", "newEnter");
        this.presentView = "nursingPage"
        this.nursingPage = true
        this.nurseBookingProfile = false
        this.bookingConfim = false
        this.nurseProfileDetails = false
        this.mapPage = false

      }
      if (data.data == 'no') {
        this.openmap()
      }
      else if (data.data == 'yes') {
        this.confirmloc = true
      }
      else if (data.data == 'nursebookinghistory') {
        // this.openBookingHis()
        this.backToNursingPage()
      }
    })
  }

  isShow: any;
  showcoment: boolean = false;
  pagenorev: any;
  async showHide() {
    this.reviewcomment = [];
    this.showcoment = true;
    this.pagenorev = 1;
    this.loadrevcomments();
    this.isShow = !this.isShow;
    if (!this.isShow) {
      this.reviewcomment.slice(-1)
      this.showcoment = false;
      this.reviewcomment = [];
      this.pagenorev = 1;
    }
  }
  nextc: any;

  loadrevcomments() {
    let requestdata = JSON.stringify({
      'limit': 10,
      'pageno': this.pagenorev,
      'vendorid': this.nurseId,
      'patientid': localStorage.getItem("patient_id"),
      'vendortypeid': 5
    })

    this.services.postRequest("getVendor_review", requestdata).subscribe(async res => {
      if (res.data != null) {
        this.nextc = res.data[res.data.length - 1].NextCount;
        for (let item of res.data) {
          this.reviewcomment.push(item)
        }
        if (this.scrollEvent) {
          this.scrollEvent.target.complete()
        }
      }
    });
  }

  async showaddress(address, myEvent) {
    let popover = await this.popoverctrl.create({
      component: ModpricetagPage,
      event: myEvent,
      componentProps: {
        address: address,
        from: "Nurse"
      },
      translucent: true,
      cssClass: 'offrMod'
    });
    popover.onDidDismiss().then((data) => {
      this.address = this.Common.address
    })
    return await popover.present();
  }

  async addMember(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: AddmemPage,
      cssClass: 'Add-Member-Page',
      componentProps: {
        getMemName: "",
        getMemGender: "",
        getMemReletion: "",
        getMemHeight: "",
        getMemWeight: "",
        getMemMobileNo: "",
        membDOB: "",
        getMemDob: "",
        memProImg: ""
      },
    })
    modal.onDidDismiss()
      .then((data) => {
        const res = data
        if (res.data.from == 2) {
          this.getPatientProfile()
        }
      })
    return await modal.present()
  }

  async viewMore(frm: any, cname: any) {
    const selectedTrueData = this.addSomething.filter(item => item.selected === true);
    let popover = await this.modalCtrl.create({
      component: ViewmodelPage,
      componentProps: {
        From: frm,
        duties: selectedTrueData,
        dateRange: this.dateRange,
        month: this.month,
        year: this.year,
        excdat: this.excludeDates,
        showformated_date: new Date().toString()?.split(' ')[0] + ", " + new Date().toString()?.split(' ')[1] + " " + new Date().toString()?.split(' ')[2]
      },
      cssClass: cname,
    })
    return await popover.present()
  }

  makeLike(Nurseid, like, frm, isLiked) {
    try {
      if (frm == 1) {
        if (this.particularProfile.isLiked == null) {
          this.particularProfile.isLiked = 'true';
          this.particularProfile.likes_count = Number(this.particularProfile.likes_count) + 1;
        }

        else if (this.particularProfile.isLiked == "false") {
          this.particularProfile.isLiked = 'true';
          this.particularProfile.likes_count = Number(this.particularProfile.likes_count) + 1;
        }
        else if (this.particularProfile.isLiked == "true") {
          this.particularProfile.isLiked = 'false';
          this.particularProfile.likes_count = Number(this.particularProfile.likes_count) - 1;
        }
      }
      else if (frm == 2) {
        if (this.particularNurseBook[0].isLiked == null) {
          this.particularNurseBook[0].isLiked = 'true';
          this.particularNurseBook[0].likes_count = Number(this.particularNurseBook[0].likes_count) + 1;
        }

        else if (this.particularNurseBook[0].isLiked == "false") {
          this.particularNurseBook[0].isLiked = 'true';
          this.particularNurseBook[0].likes_count = Number(this.particularNurseBook[0].likes_count) + 1;
        }
        else if (this.particularNurseBook[0].isLiked == "true") {
          this.particularNurseBook[0].isLiked = 'false';
          this.particularNurseBook[0].likes_count = Number(this.particularNurseBook[0].likes_count) - 1;
        }
      }
      if (this.mklike) {
        this.mklike.unsubscribe();
      }
      let data = JSON.stringify({
        "vendor_id": Nurseid,
        "like": like,
        "user_id": localStorage.getItem("patient_id"),
        "module_name": "Nurse",
        "isLiked": (isLiked == null) ? 'false' : isLiked
      });
      this.mklike = this.services.postRequestDoc("UpdateVendorLikes", data).subscribe(res => {
      }, (err) => {
      });
    } catch (err) {
    }
  }

  viewNurse_Details: boolean = false;
  //  viewNurse_details(item) {
  //   debugger
  //   // this.viewNurse_Details = true;
  //   // this.particularProfile = item;
  //   const modal =  this.modalCtrl.create({
  //     component: DefinedDutiesPage,
  //     backdropDismiss: false,
  //     cssClass: 'custom-popupfordeals',
  //     componentProps: {
  //       titleContent: "viewNurse_Details",
  //       messageContent: item,
  //     }
  //   });
  //   return  modal.present();
  //   // modal.onDidDismiss().then((data) => {
  //   //   this.viewNurse_Details = false;
  //   // })
  // }
  async viewNurse_details(data: any) {
    debugger;
    const alert = await this.modalCtrl.create({
      component: ReviewPage,
      cssClass: 'review-class',
      componentProps: {
        titleContent: "viewNurse_Details",
        messageContent: data,
      }
    });
    alert.onDidDismiss().then((data) => {
      console.log(data);
      if (data.data == 'dismiss') {
        this.viewNurse_Details = false;
      }

    })
    await alert.present();
    // const modal = await this.modalCtrl.create({
    //   component: DefinedDutiesPage,
    //   cssClass: 'View_Nurse_Details',
    //   componentProps: {
    //     titleContent: "viewNurse_Details",
    //     messageContent: data,
    //   }
    // });

    // modal.onDidDismiss().then(async (data) => {
    //   this.viewNurse_Details = false;
    // });
    // return await modal.present();
  }

  // hidecard() {
  //   this.viewNurse_Details = false;
  // }

  // st_revcom: any;

  // particularnurse_revlike() {
  //   this.st_revcom = [];
  //   this.reviewcomment = [];
  //   let requestdata = JSON.stringify({
  //     'pageno': 1,
  //     'limit': 10,
  //     'nurseid': this.nurseId,
  //     'patientid': localStorage.getItem("patient_id")
  //   })
  //   this.services.postRequest("getNursereview_like", requestdata).subscribe(async res => {
  //     debugger;
  //     if (res.msg == "Success") {
  //       if (res.data[0].review_comment != null) {
  //         this.st_revcom = JSON.parse(res.data[0].review_comment).slice(-1);
  //       }
  //       this.particularNurseBook[0].isLiked = res.data[0].liked;
  //       this.particularNurseBook[0].likes_count = res.data[0].likecount
  //     }
  //   });
  // }
  nurseObject: any;

  async addtempbooked(index: any) {
    this.nurseObject = this.patNurseSearch.find((x, i) => i == index);
    let requestdata = JSON.stringify({
      'nurseid': this.nurseObject.NurseId,
      'patientid': localStorage.getItem("patient_id")
    })
    this.services.postRequest("tempblocknurse", requestdata).subscribe(async res => {
      this.temBlockednurse = res.data[0].id;
      if (res.data[0].id != 0) {
        this.showcoment = false;
        this.dutyAlert = false;
        this.addSomething = [];
        this.dateRange = []
        this.nursingPage = false;
        this.dateCount = null;
        this.getFromTime1 = this.getFromTime
        this.getToTime1 = this.getToTime
        this.excldDays = null;
        this.myDates2 = null;
        this.openNurseDetailIndex = index

        if (localStorage.getItem("NopayGoBack") == "reschedulePage") {
          this.fromResch = true
          this.fromRepeat = false
          this.nurseBookingId = this.nurseBookingId;
          this.reschedulePatientId = this.patientId;
          this.particularBookingDetails()
          this.Enabled = false
        } else if (localStorage.getItem("NopayGoBack") == "repeatPage") {
          this.presentView = "nurseProfileDetails"
          this.frmDateAlert = false
          this.frmTimeAlert = false
          this.toTimeAlert = false
          this.fromRepeat = false
          this.fromResch = false
          this.nurseBookingId = this.nurseBookingId;
          this.currentMemberId = this.patientId;
          this.particularNurseBook = []
          this.particularBookingDetails()
          this.getPatientProfile()
          this.Enabled = false
        }
        else if (localStorage.getItem("NopayGoBack") == "editdesign") {
          this.fromResch = true
          this.fromRepeat = false
          this.nurseBookingId = this.nurseBookingId;
          this.currentMemberId = this.patientId;
          this.particullarnurseid = this.nurseId;
          this.particularBookingDetails()
          this.Enabled = false
        }
        else {
          this.addDuties = "";
          this.frmDateAlert = false;
          this.frmTimeAlert = false;
          this.fromRepeat = false;
          this.fromResch = false;
          this.dateRange = null;
          this.excludeDates = [];
          this.particularNurseBook = [];
          this.finalAmt = null;
          this.particularNurseBook.push(this.patNurseSearch[index])
          this.presentView = "nurseBookingProfile"
          this.nurseBookingProfile = true
          this.bookingConfim = false
          this.nurseProfileDetails = false
          this.mapPage = false
          this.getFromTime = "2016-07-27T04:00:00Z"
          if (this.particularNurseBook[0].eightHour == 'true') {
            this.getFromTime = ""
            this.getToTime = ""
          }
          else {
            this.getFromTime = ""
            this.getToTime = ""
          }

          this.advFilter = false
          this.addLabel = false

          if (this.particularNurseBook[0].eightHour == 'true') {
            this.workingHours = "12:00"
          } else {
            this.workingHours = "24:00"
          }

          this.ratingvalue = this.particularNurseBook[0].review
          this.nurseId = this.particularNurseBook[0].NurseId
          this.nurseVendorId = this.particularNurseBook[0].nurseVendorId
          this.amount = this.particularNurseBook[0].Cost
          // this.particularnurse_revlike();
          this.dealVal = this.particularNurseBook[0]?.dealsDetails[0]?.dealValue
          this.dealId = this.particularNurseBook[0]?.dealsDetails[0]?.dealId;

          if (this.particularNurseBook[0]?.dealsDetails[0]?.dealOption == "Amount") {
            this.dealOptn = "KWD"
            this.finalAmt = this.amount - this.dealVal
          } else if (this.particularNurseBook[0]?.dealsDetails[0]?.dealOption == "Percentage") {
            this.dealOptn = "%"
            this.finalAmt = this.amount - ((Number(this.amount) * (this.dealVal)) / 100)
          }
          else if (this.particularNurseBook[0].dealsDetails) {
            this.dealOptn = null
            this.dealVal = 0
            this.dealId = null;
            this.finalAmt = this.amount
          }
          this.optionsMulti2 = {
            pickMode: 'multi',
            weekdays: [this.addCall.title411, this.addCall.title412, this.addCall.title413, this.addCall.title414, this.addCall.title415, this.addCall.title416, this.addCall.title417],
            from: this.startDateCalendar,
            to: this.endDateCalendar,
            defaultDate: this.fromDate,
            defaultDateRange: { from: this.fromDate, to: this.toDate }
          }
        }
        getMonthDifference(new Date(), new Date(this.startDateCalendar))
        function getMonthDifference(startDate, endDate) {
          let monthdiff = endDate.getMonth() - startDate.getMonth() + 12 * (endDate.getFullYear() - startDate.getFullYear())
          for (let i = 1; i <= monthdiff; i++) {
            setTimeout(() => {
              $(".forward").trigger("click");
            }, 1000);
          }
        }
      }
      else {
        this.presentToast("The nurse is not available");
      }
    });



    //  await this.services.postRequest("particularBookingDetails", JSON.stringify({
    //   "patientId": localStorage.getItem("patient_id"),
    //   "nurseBookingId": this.nurseBookingId
    // })).subscribe(response => {
    //   this.particularNurseBook = response.data;})
    // console.log("qqqqqqqqqqqqqqqqqq",this.particularNurseBook);

  }

  onIonInfinite(ev) {
    this.scrollEvent = ev
    if (this.nextc == 0) {
      ev.target.disabled = true
    } else {
      this.pagenorev += 1;
      this.loadrevcomments();
    }
  }

  nursebooking_aval(frm) {
    debugger
    let requestdata = JSON.stringify({
      'nurseid': this.nurseId,
      "fromDate": this.fromDate,
      "toDate": this.toDate,
    })
    this.services.postRequest("check_nurseavilable", requestdata).subscribe(async res => {
      let Errorcode = res.data[0].Errorcode;
      if (res.data[0].Errorcode == 9997) {
        console.log(res.data[0].Errorcode, "error");

      }
      if (res.data[0].ErrorCode == 9999 && frm == 'profile' && res.data[0].ErrorCode != 9997) {
        this.openBooking("");
      }
      else if (res.data[0].ErrorCode == 9999 && frm == 'repeat' && res.data[0].ErrorCode != 9997) {
        this.repeatBooking();
      }
      else if (Errorcode == 9997) {
        if (frm === 'repeat') {
          this.Alertpopup(this.particularNurseBook[0].name + ',' + this.addCall.title475, 101, "frmrep")
        }
        else {
          this.Alertpopup(this.particularNurseBook[0].name + ',' + this.addCall.title475, 101, "")
        }
      }
    })
  }

  async openAdvr() {
    window.localStorage['addType'] = 2;
    let popover = await this.modalCtrl.create({
      component: AdvertisementPage,
      componentProps: {
        addImg: this.addImg
      },
      cssClass: this.dynClass,
    });
    return await popover.present();
  }

  getAdd() {
    try {
      let min = new Date(new Date().setTime(new Date().getTime() + 3600000));
      let CT = min.toISOString().split("T")[0] + "T" + min.toTimeString().split(" ")[0];
      this.tymVal = CT;
      window.localStorage['DocADD'] = CT;

      let today = new Date().toISOString().split("T")[0];
      let data = JSON.stringify({
        "vendor_type_id": 5,
        "current_date": today
      });
      this.services.postRequestGndrl("admin/get_current_advertisement", data).subscribe(res => {
        if (res.data.length > 0) {
          this.addImg = res.data[0].ad_path_name;
          if (res.data[0].ad_size == "2") {
            this.dynClass = "advertisement1";
          } else if (res.data[0].ad_size == "1") {
            this.dynClass = "advertisement2";
          }
          this.openAdvr();
        }
      }, (err) => {
      });
    } catch (err) {
    }
  }

  async presentModal1() {
    debugger;
    const modal = await this.modalCtrl.create({
      component: SuccessPage,
      backdropDismiss: false,
      cssClass: 'custom-popupfordeals',
      componentProps: {
        titleContent: 'SUCCESS!',
        messageContent: "pay",

      }
    });
    modal.onDidDismiss().then(async (data) => {
      this.gopayment = true;
      this.payType = data.data;
      const loading = await this.loadingCtrl.create({
        message: 'Please wait we are redirecting you to the payment gateway',
      })

      let number = this.formatMoney(this.total_price_per_day);
      let billamount = number.replace(/,/g, "");
      await this.storepayload();
      if (data.data == 'Credit card') {
        await loading.present();
        // this.payment.getsessionid(this.tempMemberName, "marimuthu.slpm@gmail.com", this.Phoneno, billamount).then(async (res: any) => {
        this.payment.getInitiatePayment(this.tempMemberName, "marimuthu.slpm@gmail.com", this.Phoneno, billamount)
        await loading.dismiss()
        // this.gatewayFunction(res, "MASTER");
        // })
        // this.patientNurseBooking("", "");
      } else if (data.data == "Knet") {
        await loading.present();
        // this.payment.getKnetsessionid(this.tempMemberName,"marimuthu.slpm@gmail.com", this.Phoneno, this.total_price_per_day).then(async (res: any) => {
        this.payment.getKnetPayment(this.tempMemberName, "marimuthu.slpm@gmail.com", this.Phoneno, billamount)
        await loading.dismiss();
        // this.gatewayFunction(res, "KNET");
        // })
        // this.patientNurseBooking("", "");
      }
      // else if (data.data == "3") {
      //   await loading.present();
      //   this.payment.getApplesessionid(this.tempMemberName, localStorage.getItem("Email"), this.Phoneno, this.total_price_per_day).then(async (res: any) => {
      //     await loading.dismiss();
      //     this.gatewayFunction(res, "APPLE PAY");
      //   })
      // }
      this.payType = "";
      this.gopayment = false
    })
    return await modal.present();
  }

  async showKnetPaymentDetals(data: any, msg: string) {
    const modal = await this.modalCtrl.create({
      component: knetPaymentDetailsPage,
      backdropDismiss: false,
      cssClass: 'custom-popupfordeals',
      componentProps: {
        titleContent: msg,
        messageContent: data,
      }
    });

    modal.onDidDismiss().then(async (data) => {
      if (msg === this.addCall.title620) {
        this.presentView = "paid"
        // this.router.navigate(['payment', { paymentstatus: 1 }]);
      }
    });
    return await modal.present();
  }

  showHideRev() {
    if (this.reviewCommand.length != 1) {
      if (this.showcoment == true) {
        this.showcoment = false;
      } else {
        this.showcoment = true;
      }
    } else {
      if (this.showcoment == false) {
        this.showcoment = true;
      } else {
        this.showcoment = false;
      }
    }
  }


  decryptContent(encryptedContent: string): string {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedContent, this.fkey, {
        iv: this.fiv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      return error.message;
    }
  }
  formatDate(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const monthNames = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear().toString().slice(-2);
    return `${day}-${month}-${year}`;
  }

  // openTerms() {
    getMemberNewTandC() {
      const url = this.services.apiURL() + 'admin/decryptedMemberContent_data';
      const params = new HttpParams().set('vendorcategory', 'Nurse');
  
      this.httpClient.get<DecryptedMemberContentResponse>(url, { params })
        .subscribe(
          response => {
            if (response && response.data && response.data.length > 0) {
              const lastIndex = response.data.length - 1;
              this.terms_and_condition_file = response.data[lastIndex].Terms_and_conditions;
              const decryptedData = this.decryptContent(this.terms_and_condition_file);
              console.log("Decrypted data:", decryptedData);
  
              if (!decryptedData) {
                throw new Error('Decryption failed');
              }
  
              const content = htmlToPdfmake(decryptedData);
              console.log("PDF content:", content);
  
              if (!content || !Array.isArray(content)) {
                throw new Error('Invalid content structure');
              }
  
              const documentDefinition = {
                content: content,
                styles: {
                  header: {
                    fontSize: 12,
                    bold: true,
                    margin: [40, 10, 40, 10],
                  },
                  footer: {
                    fontSize: 10,
                    margin: [40, 0, 40, 0],
                  },
                  footerText: {
                    fontSize: 10,
                  },
                },
                header: (currentPage, pageCount, pageSize) => {
                  const modified_on = new Date();
                  return {
                    text: ``,
                    alignment: 'left',
                    style: 'header',
                    color: '#510F30',
                    margin: [30, 40, 0, 0],
                  };
                },
                footer: (currentPage, pageCount, pageSize) => {
  
                  const modified_on = new Date();
  
                  return {
                    margin: [40, 40, 40, 40],
                    columns: [
                      {
                        stack: [
                          {
                            text: `Page ${currentPage}/${pageCount}`,
                            alignment: "right",
                            color: "#510F30",
                            style: "footerText",
                          },
                        ],
                      },
                    ],
                  };
                },
                pageMargins: [40, 70, 40, 180],
              };
              pdfMake.createPdf(documentDefinition).getBlob(async (blob: Blob) => {
                console.log("PDF Blob:", blob);
                try {
                  const localBlob = new Blob([blob], { type: 'application/pdf' });
                  const fileName = `report_${new Date().getTime()}.pdf`;
                  await this.file.writeFile(this.file.dataDirectory, fileName, localBlob, { replace: true })
                    .then((fileEntry) => {
                      console.log("File entry:", fileEntry);
                      this.fileOpener.open(fileEntry.nativeURL, 'application/pdf')
                        .then(() => console.log('File is opened'))
                        .catch(e => console.log('Error opening file', e));
                    })
                    .catch(e => console.log('Error writing file', e));
                } catch (error) {
                  console.error('Error uploading file', error);
                }
              });
  
            } else {
              console.error('Unexpected response format:', response);
            }
          },
          error => {
            console.error('Error:', error);
          }
        );
    }
  
    openTerms () {
      const url = this.services.apiURL() + 'admin/decryptedMemberContent_data';
      const params = new HttpParams().set('vendorcategory', 'Nurse');
  
      this.httpClient.get<DecryptedMemberContentResponse>(url, { params })
        .subscribe(
          response => {
          if (response.data && response.data && response.data.length > 0) {
            const lastIndex = response.data.length - 1;
            // setMemberTermsFileName(response.data.data[lastIndex].Terms_and_conditions);
  
            const content = htmlToPdfmake(this.Decrypted_Editor_content(response.data[lastIndex].Terms_and_conditions));
            const documentDefinition = {
              content: [...content],
              styles: {
                header: {
                  fontSize: 12,
                  bold: true,
                  margin: [40, 10, 40, 10],
                },
                footer: {
                  fontSize: 10,
  
                  margin: [40, 0, 40, 0],
                },
                main: {
                  margin: [40, 20, 40, 20],
                },
              },
              header: function (currentPage, pageCount, pageSize) {
                if (currentPage != 1) {
                } else {
                  return {
                    text: '',
                    margin: [30, 10, 0, 0],
                  }
                }
              },
              footer: function (currentPage, pageCount, pageSize) {
  
                const commonFooter = {
                  margin: [40, 0, 40, 40],
                  columns: [
                    {
                      stack: [
                        {
                          text: `Page ${currentPage}/${pageCount}`,
                          alignment: "right",
                          color: "#510F30",
                          style: "footerText",
                        },
                      ],
                    },
                  ],
                };
  
                return commonFooter;
              },
  
  
              // styles: {
              //   footerText: {
              //     fontSize: 10,
              //   },
              //   footer: {
              //     fontSize: 10,
              //     bold: true,
              //   },
              // },
              pageMargins: [40, 70, 40, 180],
            };
  
  
            pdfMake.createPdf(documentDefinition).open();
  
          }
        },
        error => {
          console.error('Error:', error);
        })
        
        // .catch(function (error) {
        //   console.error('Error in fetching contract list:', error);
        // });
    };
  
    Decrypted_Editor_content (encryptedContent) {
      const fkey = CryptoJS.enc.Hex.parse(
        "00112233445566778899aabbccddeeff00112233445566778899aabbccddeeff"
      );
      try {
        const fiv = CryptoJS.enc.Hex.parse("00112233445566778899aabbccddeeff");
        // Decrypt content
        const decryptedBytes = CryptoJS.AES.decrypt(encryptedContent, fkey, {
          iv: fiv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });
        const decryptedContent = decryptedBytes.toString(CryptoJS.enc.Utf8);
        return decryptedContent;
      } catch (error) {
        return error;
      }
    };
  
  formatMoney(number: any) {
    const num = Number(number)
    const options = {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    };

    const formattedNumber = num.toLocaleString('en-US', options);
    const parts = formattedNumber.split('.');
    if (parts.length === 1) {
      return `${formattedNumber}.000`;
    } else {
      const decimalPart = parts[1].padEnd(3, '0');
      return `${parts[0]}.${decimalPart}`;
    }
  }

  async paymentCheck() {
    if (localStorage.getItem("paymentstatus") == "cancel") {
      this.localClear();
    } else if (localStorage.getItem("paymentstatus") == "completed") {
      let payloaddata = {
        bookId: localStorage.getItem('bookindId'),
        paymentId: localStorage.getItem('resultindicator'),
        sessionid: localStorage.getItem('session'),
        referrence: localStorage.getItem("referenceid"),
        orderId: localStorage.getItem("order_on"),
        paymentGatewayName: localStorage.getItem("gatewayName"),
        paymentGatewayId :localStorage.getItem("gatewayId"),
        paymentStatus: "C",
        status: 1,
        result: "Success",
        amount: localStorage.getItem("paymentAmt")
      }
      if (payloaddata.paymentGatewayName == "KNET") {
        this.gatewayFunction(payloaddata, "KNET");
      } else {
        this.gatewayFunction(payloaddata, "MASTER");

      }

      console.log(payloaddata);

      var data = JSON.parse(localStorage.getItem("paymentObject"));

    } else if (localStorage.getItem("paymentstatus") == "failed") {
      this.localClear();
    }
  }
  localClear() {
    localStorage.setItem("paymentstatus", "");
    localStorage.setItem("resultindicator", "");
    localStorage.setItem("session", "");
    localStorage.setItem("order_on", "");
    localStorage.setItem("paymentGatewayName", "");
    localStorage.removeItem("gatewayName");
    localStorage.removeItem("gatewayId");

  }

  async storepayload() {
    if (this.myDates == null) {
      this.myDates = ""
    } else {
      this.myDates
    }
    this.dutyArray = this.dutyArray.filter((item) => item.selected == true)
    this.tempDutyArray = JSON.parse(JSON.stringify(this.dutyArray))
    for (let item of this.tempDutyArray) {
      delete item["selected"]
    }

    this.today = new Date().toJSON().split("T")[0]
    let requestdata = JSON.stringify({
      "nurseId": this.nurseId,
      "designedDuties": this.tempDutyArray,
      "excludeDate": this.myDates2,
      "isMember": this.currentMemberId == 0 ? 0 : 1,
      "tempMemberName": this.tempMemberName,
      "fromDate": this.fromDate,
      "toDate": this.toDate,
      "patientId": localStorage.getItem("patient_id"),
      "nurseVendorId": this.nurseVendorId,
      "fromTime": this.getFromTime,
      "toTime": this.getToTime,
      "workingHours": this.workingHours,
      "bookedDate": this.today,
      "amount": this.price_per_day,
      "finalamount": this.total_price_per_day,
      "deal": this.dealVal,
      "dealId": this.dealId,
      "dealoption": this.dealOptn,
      "paymentStatus": "1",
      "latitude": this.latitude,
      "longitude": this.longitude,
      "address": this.address,
      "walk_in": this.routeId,
    })

    localStorage.setItem("requestdata", requestdata)
  }

  async getbookingdetails() {
    debugger
    this.rangeFromDate = new Date(this.fromDate).toISOString().split("T")[0];
    this.rangeToDate = new Date(this.toDate).toISOString().split("T")[0];
    let data = {
      id: this.routeId,
      fromDate: this.rangeFromDate,
      toDate: this.rangeToDate,
    }

    this.searchRequest = this.services.postRequest("getMemberWalkinNurseDetails", data).subscribe(response => {
      this.vendorId = response.data[0].details[0].nurseVendorId
      if (response.data[0].details[0].Paymentstatus == "Already Paid" || localStorage.getItem("paymentstatus") == "completed") {
        localStorage.setItem("walkPaymentstatus", response.data[0].details[0].Paymentstatus)
        this.presentView = "paid";
        // this.patientNurseSearch();
      } else {
        this.showNursingPage('default')      }

    })
  }
}



